<template>
  <div class="all_game">
    <breadcrumb :link-list="selectGameBreadcrumbList"></breadcrumb>
    <div class="list">
      <div class="product_type">
        <div id="product_type_box">
          <div id="product_type">
            <div class="product_type_img">
              <img :src="game_image" alt="" :style="game_image?'display:block':'display:none'">
            </div>
            <div class="product_type_content">
              <div class="product_type_title">选择商品类型</div>
              <div class="product_type_list">
                <div class="product_type_option" :class="item.id === productTypeSelect?'product_type_select':''"
                     v-for="(item,index) in productType" :key="`productType${index}`" @click="productTypeClick(item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="otherBusiness" v-if="this.$route.query.game_id == '26'">
            <router-link :to="item.link" class="otherBusiness_item" v-for="(item,index) in otherBusiness"
                         :key="`otherBusiness${index}`"
                         :style="`color:${item.color}`">
              {{ item.name }}
              <div class="otherBusiness_tag" v-if="item.hot || item.new">
                <img src="@/assets/image/AllGame/selectGame/hotTag.gif" alt="" v-if="item.hot">
                <img src="@/assets/image/AllGame/selectGame/newTag.png" alt="" v-else-if="item.new">
              </div>
            </router-link>
          </div>

        </div>
      </div>
      <div class="filter">
        <div class="filter_ground">
          <div v-for="(item,index) in filterData" :key="`filter${index}`" class="equipment">
            <div>{{ item.cat_name }}：</div>
            <ul>
              <el-radio v-for="(items,indexs) in item.entries" :key="`filterData_entries${indexs}`"
                        v-model="filterForm[item.cat_id]"
                        @change="filterItemClick(item,items)" :label="items.id">{{ items.name }}
              </el-radio>
            </ul>
          </div>
          <div class="equipment is_gaoji" v-if="filterOptions.length>0">
            <div class="is_gaoji_title">高级选项：</div>
            <ul>
              <!--              <li v-for="(item,index) in filterOptions" :key="index" class="is_gaoji_select" v-show="productTypeSelect === 2 && item.show">-->
              <li v-for="(item,index) in filterOptions" :key="`filterOptions${index}`" class="is_gaoji_select"
                  v-show="item.entries.length !== 0">
                <div class="optionsLable">{{ item.cat_name }}</div>
                <el-select :popper-append-to-body="false"
                           v-model="filterForm[item.cat_id]"
                           multiple
                           collapse-tags
                           clearable
                           filterable
                           @change="(val)=>optionSelect(val,item,'','')"
                           placeholder="请选择">
                  <el-option
                    v-for="(items,indexs) in item.entries"
                    :key="`optionsLable${indexs}`"
                    :label="items.name"
                    :value="items.id">
                  </el-option>
                </el-select>
              </li>
            </ul>
          </div>
          <div class="equipment is_gaoji" v-for="(item,index) in filterGrouping" :key="`filterGrouping${index}`">
            <div class="is_gaoji_title">{{ item.cat_name }}：</div>
            <ul>
              <li v-for="(Eitem,Eindex) in item.entries" :key="`Eindex${Eindex}`" class="is_gaoji_select">
                <div class="optionsLable">{{ Eitem.cat_name }}</div>
                <el-select :popper-append-to-body="false"
                           v-model="filterForm[Eitem.cat_id]"
                           multiple
                           collapse-tags
                           clearable
                           filterable
                           @change="(val)=>optionSelect(val,item,Eitem,'filterGrouping')"
                           placeholder="请选择">
                  <el-option
                    v-for="items in Eitem.entries"
                    :key="items.id"
                    :label="items.name"
                    :value="items.id">
                  </el-option>
                </el-select>
              </li>
            </ul>
          </div>
          <!-- 盼之多层级筛选(独立面板)：国标/英雄分路/全皮/星元/战令/限定套系/稀有英雄/连体/关键词等，手风琴折叠 -->
          <div class="ml-dim" v-for="dim in mlDims" :key="dim.code">
            <div class="ml-label">{{ dim.name }}：</div>
            <div class="ml-body">
              <ml-branch :node="dim" :sel="mlSel" @toggle-leaf="mlToggle" />
            </div>
          </div>
          <div class="matchSearch">
            <div>关键词搜索：</div>
            <div class="searchInputWrap">
              <el-input
                v-if="productTypeSelect === 1"
                placeholder="请输入关键词搜索"
                class="searchInput"
                clearable
                v-model.trim="matchCon"
                @keydown.enter.native="scopeValueClick"
                @keyup.enter="searchSubmit"
                @keydown="inputKeyDown"
                @focus="showRecommend=true"
                @blur="showRecommend=false;recommendIndex=-1" @input="handleInput" autocomplete="off"
                @compositionstart="flag = false" @compositionend="flag = true">
              </el-input>
              <el-input
                v-else
                placeholder="请输入关键词搜索"
                class="searchInput"
                clearable
                v-model="matchCon">
              </el-input>
              <button class="searchButton" type="button" @click="scopeValueClick">
                <i class="el-icon-search"></i>
              </button>
            </div>
            <div class="search_recommend" v-show="showRecommend  && recommendList.length>0">
              <div class="item" :class="{'active':index === recommendIndex}" v-for="(item,index) in recommendList"
                   :key="`recommendList${index}`" @mousedown="clickRecommend(item)">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
          <div class="sellSincerity" v-if="productTypeSelect === 1">
            <div class="sellSincerity-ttile">诚心卖：</div>
            <el-select :popper-append-to-body="false"
                       v-model="services"
                       clearable
                       @change="SellSincereScreen"
                       placeholder="请选择">
              <el-option label="全部" value="all"></el-option>
              <el-option label="已购买诚心卖服务" value="1"></el-option>
              <el-option label="未购买诚心卖服务" value="0"></el-option>
            </el-select>
          </div>
          <div class="price">
            <!-- 数据驱动 RANGE 维度(value_type=RANGE)：王者皮肤/传说/史诗等由后端字典(facet_key)驱动，替换原硬编码 -->
            <div class="skin_value" v-for="(r, ri) in filterRanges" :key="'range' + ri">
              <div>{{ r.cat_name }}{{ r.unit ? '（' + r.unit + '）' : '' }}：</div>
              <input type="text" class="min_price" v-model="scopeValue['min_' + r.facet_key]" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue['max_' + r.facet_key]" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
            </div>
            <div class="price_price" v-if="game_name === '英雄联盟'">
              <div>皮肤数量：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_skin" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_skin" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
            </div>
            <div :class="game_name === '英雄联盟'? 'skin_value' : 'price_price'">
              <div>价格：</div>
              <input type="number" class="min_price" v-model="scopeValue.min_price" placeholder="请输入">
              <div class="scope">—</div>
              <input type="number" class="max_price" v-model="scopeValue.max_price" placeholder="请输入">
            </div>
            <!-- 王者荣耀 -->
            <div class="hero_value" v-if="gameInfo.game_alias === 'wzry'">
              <div>贵族等级：</div>
              <input type="number" class="min_price" v-model="scopeValue.min_level" placeholder="请输入"
                     oninput="if(value>10)value=10;value=value.replace(/^(0+)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="number" class="max_price" v-model="scopeValue.max_level" placeholder="请输入"
                     oninput="if(value>10)value=10;value=value.replace(/^(0+)|[^\d]+/g,'')">
            </div>
            <div class="hero_value" v-if="game_name === '英雄联盟'">
              <div>英雄数量：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_hero" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_hero" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
            </div>

            <!-- 原神 || 崩坏星穹铁道 -->
            <div class="hero_value" v-if="game_name === '原神' || gameInfo.game_alias === 'bhxqtd'">
              <div>黄数：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_yellow" placeholder="请输入"
                     oninput="if(value>999)value=999;value=value.replace(/^(0+)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_yellow" placeholder="请输入"
                     oninput="if(value>999)value=999;value=value.replace(/^(0+)|[^\d]+/g,'')">
            </div>
            <!-- 和平精英 -->
            <div class="hero_value" v-if="gameInfo.game_alias === 'hpjy'">
              <div>信誉分：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_credit" placeholder="请输入"
                     oninput="if(value>100)value=100;value=value.replace(/^(0+)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_credit" placeholder="请输入"
                     oninput="if(value>100)value=100;value=value.replace(/^(0+)|[^\d]+/g,'')">
            </div>
            <div class="hero_value" v-if="gameInfo.game_alias === 'hpjy'">
              <div>车数：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_cars" placeholder="请输入"
                     oninput="if(value>999)value=999;value=value.replace(/^(0+)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_cars" placeholder="请输入"
                     oninput="if(value>999)value=999;value=value.replace(/^(0+)|[^\d]+/g,'')">
            </div>
            <div class="power_value" v-if="game_name === '天涯明月刀'">
              <div>功力值：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_gongli" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_gongli" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
            </div>
            <div class="charm_value" v-if="game_name === '天涯明月刀'">
              <div>魅力值：</div>
              <input type="text" class="min_price" v-model="scopeValue.min_meili" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
              <div class="scope">—</div>
              <input type="text" class="max_price" v-model="scopeValue.max_meili" placeholder="请输入"
                     oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')">
            </div>

            <div class="area_value" v-if="['32','159'].includes(`${game_id}`)">
              <div>区服：</div>
              <input
                type="number"
                class="min_price"
                v-model="scopeValue.min_server"
                placeholder="请输入"

              />
              <div class="scope">—</div>
              <input
                type="number"
                class="max_price"
                v-model="scopeValue.max_server"
                placeholder="请输入"
              >
            </div>
            <div class="v_number_value" v-if="['39'].includes(`${game_id}`)">
              <div>V数量：</div>
              <input type="number" class="min_price" v-model="scopeValue.min_v_number" placeholder="请输入">
              <div class="scope">—</div>
              <input type="number" class="max_price" v-model="scopeValue.max_v_number" placeholder="请输入">
            </div>
            <div class="price_filter" @click="scopeValueClick">筛选</div>
          </div>
        </div>
      </div>
      <div class="search">
        <div class="search_left">
          <span class="sort" v-for="(item,index) in sortItem" :key="`sortItem${index}`"
                :class="item.type === sortItemIndex?'sort_checked':''" @click="clickSortItem(item)">
            <span>{{ item.name }}</span>
            <i v-if="item.type !== ''" class="el-icon-caret-top" :class="sortItemMethod === 2?'sort2':''"></i>
            <i v-if="item.type !== ''" class="el-icon-caret-bottom" :class="sortItemMethod === 1?'sort1':''"></i>
          </span>
        </div>
        <div class="top" v-if="this.productTypeSelect===1">
          <el-checkbox v-model="topAccShow" @change="topChange">仅显示顶级账号</el-checkbox>
        </div>
        <div class="search_right" @click="emptyOptions">
          <i class="el-icon-delete"></i>
          <div class="search_right_text">清空所有筛选</div>
        </div>
      </div>
      <div class="game_list" v-if="productTypeSelect === 1" v-loading="loading">
        <div class="game_other_business" v-if="this.$route.query.game_id == '26'">
          <img src="../../../assets/image/AllGame/selectGame/OB_decoration.png" alt="">
          <div class="game_other_business_list">
            <router-link :to="item.link" class="game_other_business_item" v-for="(item,index) in otherBusiness"
                         :key="`gameotherBusiness${index}`">
              <img :src="item.img" alt="">
              <div class="game_other_business_tag" v-if="item.hot || item.new">
                <img src="@/assets/image/AllGame/selectGame/hotTag.gif" alt="" v-if="item.hot">
                <img src="@/assets/image/AllGame/selectGame/newTag.png" alt="" v-else-if="item.new">
              </div>
            </router-link>
          </div>
          <img src="../../../assets/image/AllGame/selectGame/OB_decoration.png" alt="">
        </div>
        <router-link :to="{name:'Legal',query:{id:'113',parent_id:'13'}}" class="game_list_banner" v-else>
          <img src="@/assets/image/AllGame/gameListBanner.png" alt="">
        </router-link>
        <div v-if="gameListData.length>0">
          <div class="game_list_details_box" v-for="(item,index) in gameListData" :key="`gameListData${index}`"
               :id="index === gameListData.length-1?'game_list_details_box_last':''">
            <div class="game_list_details" @click="AccountClick(item,index)">
              <router-link class="details_img" target="_blank"
                           :to="{name:'GameDetails',query:{game_id:game_id,id:item.id,source_page: $route.path.slice(1)}}">
                <img :src="item.image" alt="" :style="item.id_api_shangjia?'':'height:100%;object-fit:cover'">
              </router-link>
              <img class="topAcc" src="@/assets/image/AllGame/gameDetails/topAcc.png" alt=""
                   v-if="item.is_dingji === 1">
              <div class="details_info">
                <img class="apexTag" v-if="item.is_hunt === 1" :style="`left:${item.is_cert === 1?'85px':'0px'}`"
                     src="../../../assets/image/AllGame/gameDetails/apexTag.png" alt="">
                <router-link class="details_info_top" target="_blank"
                             :to="{name:'GameDetails',query:{game_id:game_id,id:item.id,source_page: $route.path.slice(1)}}">
                  <span class="DIT_gameName">
                    <img v-if="item.is_cert === 1" src="../../../assets/image/AllGame/gameDetails/bsmTag.png" alt="">
                  </span>
                  <span :style="`margin-left:${item.is_hunt === 1?'89px':'0px'}`" v-html="`【${game_name}】${item.name}`"
                        style="vertical-align: super;"></span>
                </router-link>
                <div class="game_list_details_content">
                  <div class="game_list_details_content_title">商品详情</div>
                  <div class="game_list_details_content_detail" v-html="item.name"></div>
                </div>
                <div class="details_info_mid">
                <span v-for="(categoryItem,index) in item.category" :key="`gamecategory${index}`">
                  {{ categoryItem.name }}:
                  {{ categoryItem.value }}
                </span>
                </div>
                <div class="details_info_bot">
                  <span class="release_time">发布时间：{{ item.up_time|moment }}</span>
                  <span class="hot_pic"><img src="@/assets/image/Home/topGamesIco.png" alt="">{{ item.click }}</span>
                </div>
              </div>
              <div class="details_price" v-if="item.price > 0">
                <div class="priceBadges" v-show="item.is_willing == 1">
                  <sell-sincerity></sell-sincerity>
                </div>
                <div class="priceValue">¥{{ item.price }}</div>
                <div class="priceTags">
                  <img v-if="item.is_sign === 1" src="@/assets/image/AllGame/isSign.png" alt="">
                  <img v-if="item.bind_psn === 1" src="@/assets/image/AllGame/bindPsn.png" alt="">
                  <img v-if="item.bind_tap === 1" src="@/assets/image/AllGame/bindTap.png" alt="">
                  <div class="renewalTap" v-if="is_renewal === 1 && item.acc_source === 1">
                    <img src="@/assets/image/AllGame/renewalTap.png" alt="">
                    <div class="renewalTooltip">
                      此账号来源为游严选购买
                    </div>
                  </div>
                </div>
              </div>
              <div class="details_price" v-else></div>
              <div class="details_btn">
                <router-link class="detailsPrimaryBtn" target="_blank"
                             :to="{name:'GameDetails',query:{game_id:game_id,id:item.id, source_page: $route.path.slice(1)}}">
                  查看详情
                </router-link>
                <div v-if="sys_service_type==2 || sys_service_type==3" @click="cusSerBtnClicks(item)">咨询客服</div>
                <!-- <div v-else @click="cusSerBtnClick(item)">咨询客服</div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="select_game_empty" v-else>
          <empty-state
            title="您搜索的商品未在售~"
            description="可以尝试更换关键词或浏览其他游戏商品"
          ></empty-state>
        </div>
        <div class="pages" v-show="totalCount>0">
          <common-pagination
            :current-page.sync="currentPage"
            :page-size="PageSize"
            layout="total,prev, pager, next, jumper"
            :total="totalCount"
            @current-change="handleCurrentChange">
          </common-pagination>
        </div>
      </div>
      <div class="equip_list" v-else-if="productTypeSelect === 2" v-loading="loading">
        <router-link :to="{name:'Legal',query:{id:'113',parent_id:'13'}}" class="equip_list_banner">
          <img src="@/assets/image/AllGame/gameListBanner.png" alt="">
        </router-link>
        <template v-if="gameListData.length>0">
          <div class="equip_list_header">
            <div class="EL_header_baseInfo">商品信息</div>
            <div class="EL_header_sellPrice">商品单价</div>
            <div class="EL_header_num">商品库存</div>
            <div class="EL_header_btn"></div>
          </div>
          <div class="equip_list_details_box" v-for="(item,index) in gameListData" :key="`equipListData${index}`"
               :id="index === gameListData.length-1?'equip_list_details_box_last':''">
            <div class="equip_list_details">
              <div class="details_base_info">
                <router-link class="details_img" target="_blank"
                             :to="{name:'EquipmentDetails',query:{game_id:game_id,id:item.id}}">
                  <img :src="item.image" alt="">
                </router-link>
                <div class="details_info">
                  <router-link class="details_info_top" target="_blank"
                               :to="{name:'EquipmentDetails',query:{game_id:game_id,id:item.id}}">
                    <div class="details_info_top_name">
                      <span>{{ game_name }}</span>{{ item.name }}
                    </div>
                    <div class="details_info_top_content">
                      {{ item.content }}
                    </div>
                  </router-link>
                  <div class="equip_list_details_content">
                    <div class="equip_list_details_content_title">商品详情</div>
                    <div class="equip_list_details_content_detail">
                      {{ item.name }}
                    </div>
                  </div>
                  <div class="details_info_mid">
                <span v-for="(categoryItem,index) in item.category" :key="`equipcategory${index}`">
                  {{ categoryItem.name }}:
                  {{ categoryItem.value }}
                </span>
                  </div>
                  <div class="details_info_bot">
                    <span class="release_time">发布时间：{{ item.up_time|moment }}</span>
                    <span class="hot_pic"><img src="@/assets/image/Home/topGamesIco.png" alt="">{{ item.click }}</span>
                  </div>
                </div>
              </div>
              <div class="details_price" v-if="item.sell_price > 0">
                ¥{{ item.sell_price }}
                <div></div>
                <img v-if="item.is_proof === 1" src="@/assets/image/AllGame/is_proof.png" alt="">
              </div>
              <div class="details_price" v-else></div>
              <div class="details_num">
                {{ item.num }}
              </div>
              <div class="details_btn">
                <router-link class="detailsPrimaryBtn" target="_blank" :to="{name:'EquipmentDetails',query:{game_id:game_id,id:item.id}}">查看详情
                </router-link>
                <div v-if="sys_service_type==2 || sys_service_type==3" @click="cusSerBtnClicks(item)">咨询客服</div>
                <!-- <div v-else @click="cusSerBtnClick(item)">咨询客服</div> -->
              </div>
            </div>
          </div>
        </template>
        <div class="select_game_empty" v-else>
          <empty-state
            title="您搜索的商品未在售~"
            description="可以尝试更换关键词或浏览其他游戏商品"
          ></empty-state>
        </div>
        <div class="pages" v-show="totalCount>0">
          <common-pagination
            :current-page.sync="currentPage"
            :page-size="PageSize"
            layout="total,prev, pager, next, jumper"
            :total="totalCount"
            @current-change="handleCurrentChange">
          </common-pagination>
        </div>
      </div>
      <div class="gold_list" v-else-if="productTypeSelect === 3" v-loading="loading">
        <router-link :to="{name:'Legal',query:{id:'113',parent_id:'13'}}" class="gold_list_banner">
          <img src="@/assets/image/AllGame/gameListBanner.png" alt="">
        </router-link>
        <template v-if="gameListData.length>0">
          <div class="gold_list_header">
            <div class="GL_header_baseInfo">商品信息</div>
            <div class="GL_header_sellPrice">商品单价</div>
            <div class="GL_header_num">商品库存</div>
            <div class="GL_header_btn"></div>
          </div>
          <div class="gold_list_details_box" v-for="(item,index) in gameListData" :key="`goldListData${index}`"
               :id="index === gameListData.length-1?'gold_list_details_box_last':''">
            <div class="gold_list_details">
              <div class="details_base_info">
                <router-link class="details_img" target="_blank"
                             :to="{name:'GoldDetails',query:{game_id:game_id,id:item.id}}">
                  <img :src="item.image" alt="">
                </router-link>
                <div class="details_info">
                  <router-link class="details_info_top" target="_blank"
                               :to="{name:'GoldDetails',query:{game_id:game_id,id:item.id}}">
                    <div class="details_info_top_name">
                      <span>{{ game_name }}</span>{{ item.name }}
                    </div>
                    <div class="details_info_top_content">
                      {{ item.content }}
                    </div>
                  </router-link>
                  <div class="gold_list_details_content">
                    <div class="gold_list_details_content_title">商品详情</div>
                    <div class="gold_list_details_content_detail">
                      {{ item.name }}
                    </div>
                  </div>
                  <div class="details_info_mid">
                <span v-for="(categoryItem,index) in item.category" :key="`details_info_mid${index}`">
                  {{ categoryItem.name }}:
                  {{ categoryItem.value }}
                </span>
                  </div>
                  <div class="details_info_bot">
                    <span class="release_time">发布时间：{{ item.up_time|moment }}</span>
                    <span class="hot_pic"><img src="@/assets/image/Home/topGamesIco.png" alt="">{{ item.click }}</span>
                  </div>
                </div>
              </div>
              <div class="details_price" v-if="item.sell_price > 0 ">
                ¥{{ item.sell_price }}
                <div class="gold_convert">
                  <div class="gold_convert_title">换算比例</div>
                  <div class="gold_convert_text">
                    <div class="gold_unit_num">1元={{ (item.unit_num * 1).toFixed(0) }}<span
                      v-if="item.unit === 2">万</span>金
                    </div>
                    <div class="gold_unit_price">1<span
                      v-if="item.unit === 2">万</span>金={{ (item.unit_price * 1).toFixed(2) }}元
                    </div>
                  </div>
                </div>
              </div>
              <div class="details_price" v-else></div>
              <div class="details_num">
                {{ item.num }}
              </div>
              <div class="details_btn">
                <router-link class="detailsPrimaryBtn" target="_blank" :to="{name:'GoldDetails',query:{game_id:game_id,id:item.id}}">查看详情
                </router-link>
                <div v-if="sys_service_type==2 || sys_service_type==3" @click="cusSerBtnClicks(item)">咨询客服</div>
                <!-- <div v-else @click="cusSerBtnClick(item)">咨询客服</div> -->
              </div>
            </div>
          </div>
        </template>
        <div class="select_game_empty" v-else>
          <empty-state
            title="您搜索的商品未在售~"
            description="可以尝试更换关键词或浏览其他游戏商品"
          ></empty-state>
        </div>
        <div class="pages" v-show="totalCount>0">
          <common-pagination
            :current-page.sync="currentPage"
            :page-size="PageSize"
            layout="total,prev, pager, next, jumper"
            :total="totalCount"
            @current-change="handleCurrentChange">
          </common-pagination>
        </div>
      </div>
    </div>
    <myDialog :text="'尊敬的游严选VIP您好，根据相关法律法规要求，需实名认证方可进行购买。'" :btn-text="'去实名'" btn :show="realNameShow"
              :close-fun="mydialogClose" :btn-fuc="mydialogBtnClick"
    ></myDialog>
    <el-dialog
      :visible.sync="centerDialogVisible"
      custom-class="contactCusSer"
      :show-close="false"
      width="500px"
      top="35vh"
      center>
          <span>
            <div id="contactCusSer">
              <div class="contactCusSer_title">
                请添加微信号或QQ号联系客服
              </div>
              <a v-if="sys_service_type==2 || sys_service_type==3" @click="cusSerBtnClicks(product)"
                 href="#"
                 class="onlineCus">在线客服</a>
              <a v-else target="_blank" @click="historyAdd" class="onlineCus">在线客服</a>
              <div class="contactCusSer_tip">友情提示：在线客服聊天更顺畅！</div>
            </div>
          </span>
    </el-dialog>
    <left-product v-if="gameInfo.game_alias === 'yuanshen'" :product_id="0" :game_id="game_id"></left-product>
    <!-- <el-dialog
        :visible.sync="ssmQuestion"
        custom-class="ssmQuestion"
        :show-close="false"
        width="430px"
        top="35vh"
        center>
      <div id="ssmQuestion">
        <div class="answer">
          <div class="title">
            <img src="@/assets/image/AllGame/gameDetails/sell.png" alt="">
          </div>
          <div class="text">
            须等待卖家上线沟通
          </div>
          <div class="chat" @click="cusSell()">
            <img src="@/assets/image/AllGame/gameDetails/sell_chat.png" alt="">
          </div>
        </div>
        <div class="answer">
          <div class="title">
            <img src="@/assets/image/AllGame/gameDetails/curs.png" alt="">
          </div>
          <div class="text">
            由官方客服联系卖家
          </div>
          <div class="chat" @click="ssmQuestion=false,cusSers()">
            <img src="@/assets/image/AllGame/gameDetails/cus_chat.png" alt="">
          </div>
        </div>
        <img class="close" src="../../../assets/image/AccountDeal/close.png" alt="" @click="ssmQuestion = false">
      </div>
    </el-dialog> -->
    <buyer-to-sell-on-chat @cusSers="cusSers(game_id,product_id)" @cusSell="cusSell()"
                           :visible.sync="ssmQuestion"></buyer-to-sell-on-chat>
  </div>
</template>
<script>
import {
  apiProductCategory,
  apiProductPcate,
  apiProductMultilevel,
  apiProductList,
  apiGoldCategory,
  apiGoldAttr,
  apiGoldList,
  apiEquipCategory,
  apiEquipAttr,
  apiEquipList,
  apiStatisticsAdd,
  apiHistoryCusAdd,
  apiPSearchList,
  searchParticiple,
  apiGameInfo,
  apiuserInfo,
  apiConsult,
  apiProductBuyCheck
} from "@/request/API";
import LeftProduct from "../../../components/leftProduct";
import myDialog from "@/components/myDialog";
import BuyerToSellOnChat from '../gameDetails/components/buyerToSellOnChat.vue';
import SellSincerity from '../components/sellSincerity.vue';
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
import Breadcrumb from "@/components/breadcrumb";
import MlBranch from "./MlBranch.vue";

export default {
  name: '',
  components: {LeftProduct, myDialog, BuyerToSellOnChat, SellSincerity, CommonPagination, EmptyState, Breadcrumb, MlBranch},
  data() {
    return {
      gameInfo: {},
      //立即购买 实名弹窗
      realNameShow: false,
      breadCrumbs: '',
      game_id: this.$route.query.game_id,
      game_name: this.$route.params.game_name,
      game_class: this.$route.params.game_class,
      game_image: this.$route.params.game_image,
      buy_group: '',
      product: {},
      game_customer: '',
      matchCon: this.$route.query.matchCon,
      services: 'all',
      //商品类型
      productType: this.$route.params.game_service,
      //商品类型选中
      productTypeSelect: 1,
      //筛选 表单
      filterForm: {},
      //筛选 单选数据
      filterData: [],
      //筛选 多选下拉框数据
      filterOptions: [],
      filterGrouping: [],
      //筛选 区间数据(value_type=RANGE，数据驱动，见 DESIGN-search-wzry-multilevel.md Phase 1b)
      filterRanges: [],
      //盼之多层级筛选(独立面板)：多级维度(国标/英雄分路/全皮/星元/战令/限定套系/稀有英雄/连体/关键词等)
      mlDims: [],        //要渲染的维度(含 children 级联，交给 MlBranch 递归渲染)
      mlSel: {},         //leaf.code -> true (已选叶子)
      optionsValue: '',
      //筛选 范围表单
      scopeValue: {
        min_price: '',
        max_price: '',
        min_v_number: '',
        max_v_number: '',
        min_server: '',
        max_server: ''
        // min_gongli:'',
        // max_gongli:'',
        // min_meili:'',
        // max_meili:'',
      },
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 默认每页显示的条数（可修改）
      PageSize: 15,
      text: ``,
      //排序选项
      sortItem: [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        // {name:'功力',type:'gongjisort'},
        // {name:'魅力',type:'meilisort'},
      ],
      //排序当前选项
      sortItemIndex: '',
      //排序方式 0不筛选(默认) 1降序 2升序
      sortItemMethod: 2,
      // rec顶级账号列表
      rec: '',
      //账号列表 数据
      gameListData: [],

      centerDialogVisible: false,
      //装备 昨日成交订单
      yesterdayDeal: 0,
      productId: '',

      //仅显示顶级账号
      topAccShow: false,
      //搜索推荐
      recommendList: [],
      recommendIndex: -1,
      showRecommend: false,
      setTimeOut: null,
      flag: true,
      //原神业务
      otherBusiness: [
        // {name:'自抽号',hot:true,new:false,color:'rgba(54, 54, 54, 1)',link:`/selfDraw?game_id=${this.$route.query.game_id}`,img:require('../../../assets/image/AllGame/selectGame/OB_item1.png')},
        {
          name: '自抽号',
          hot: true,
          new: false,
          color: 'rgba(54, 54, 54, 1)',
          link: `/gamedetails?game_id=26&id=1986&source_page=${this.$route.path.slice(1)}`,
          img: require('../../../assets/image/AllGame/selectGame/OB_item1.png')
        },
        {
          name: '初始号',
          hot: true,
          new: false,
          color: 'rgba(54, 54, 54, 1)',
          link: `/gamedetails?game_id=26&id=23160&source_page=${this.$route.path.slice(1)}`,
          img: require('../../../assets/image/AllGame/selectGame/OB_item2.png')
        },
        {
          name: '代肝',
          hot: false,
          new: true,
          color: 'rgba(242, 0, 0, 1)',
          link: '/training',
          img: require('../../../assets/image/AllGame/selectGame/OB_item3.png')
        },
        {
          name: '售后案例',
          hot: false,
          new: false,
          color: 'rgba(54, 54, 54, 1)',
          link: '/legal?id=113&parent_id=13',
          img: require('../../../assets/image/AllGame/selectGame/OB_item4.png')
        },
      ],
      // 是否53客服/游严选客服
      sys_service_type: 0,
      is_open_trans_chat: 0,
      is_merchant_no: 1,
      ssmQuestion: false,
      product_id: '',
      loading: false
    }
  },
  methods: {
    /**
     * @description: 咨询卖家
     * @return {*}
     */
    async cusSell() {
      let userInfo = await apiuserInfo({action: 'verified'})
      if (
        (userInfo.data.cert_id === '' &&
          this.$store.state.systemInfo.real_name_auth == '1' &&
          this.$store.state.userData.country_code == '86') ||
        (userInfo.data.cert_id === '' &&
          this.$store.state.systemInfo.real_name_auth == '0')
      ) {
        this.realNameShow = true
        this.ssmQuestion = false
        return
      }
      apiConsult({
        game_id: this.game_id,
        goods_id: this.product_id
      }).then(res => {
        this.ssmQuestion = false
        this.$openIM({
          product_id: this.product_id,
          product_type: this.productTypeSelect,
          room_id: res.data.room_id,
          gameAlias: this.$route.query.gameAlias
        })
      }).catch(e => {
      })
    },
    /**
     * 立即购买按钮
     */
     onlineBuy(game_id, id){
      if (!this.$store.state.loginStatus) {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: game_id,
            id: id,
          },
        })
        return;
      }
      apiProductBuyCheck({
        game_id:game_id,
        id:id,
      }).then(res=>{
        let routeUrl = this.$router.resolve({
          name: 'OnlineDeal',
          query: {
            id: id,
            game_id:game_id
          }
        });
        window.open(routeUrl.href, '_blank');
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    cusSers(game_id, id) {
      // return
      if (this.productTypeSelect === 1) {
        //访问统计
        apiStatisticsAdd({
          game_id: game_id,
          product_id: id,
          statistics_type: 3
        })
      }
      if(game_id && id){
        this.$customerShunt.getBuyOrGroupCode(id, game_id, this.productTypeSelect, (data) => {
          if(data.game_buy_status){
            data.allot_group_buy_status ? this.onlineBuy(game_id, id) : this.$openIM({
              product_id: this.product_id,
              game_id: this.game_id,
              shopid: id,
              product_type: this.productTypeSelect,
              gameAlias: data.group_code,
              im_type: 3
            })
          } else {
            this.$openIM({
              product_id: this.product_id,
              game_id: this.game_id,
              shopid: id,
              product_type: this.productTypeSelect,
              gameAlias: data.group_code,
              im_type: 3
            })
          }
        })
      } else {
        this.$openIM({
          product_id: this.product_id,
          game_id: this.game_id,
          shopid: id,
          product_type: this.productTypeSelect,
          gameAlias: this.$route.query.gameAlias
        })
      }
    },
    /**
     * 关闭实名认证提示框
     */
    mydialogClose() {
      this.realNameShow = false
    },
    mydialogBtnClick() {
      this.$router.push({
        path: '/personalCenter/personalInfo/rNameAuthentication',
        query: {
          Rurl: this.$route.fullPath,
        },
      })
    },
    async cusSerBtnClicks(item) {
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({action: 'verified'})
        if (userInfo.data.cert_id === '' && this.$store.state.systemInfo.real_name_auth == '1' && this.$store.state.userData.country_code == '86') {
          this.realNameShow = true
          return
        }
        this.product_id = item.id
        apiHistoryCusAdd({
          game_id: this.game_id,
          product_id: item.id,
          product_type: this.productTypeSelect
        })

        if (this.is_open_trans_chat == 1 && item.is_merchant_no == 0) {
          this.ssmQuestion = true
        } else {
          this.cusSers(this.game_id, item.id)
        }
      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    async historyAdd() {
      this.$accessLink(this.game_customer)
      apiHistoryCusAdd({
        game_id: this.game_id,
        product_id: this.productId,
        product_type: this.productTypeSelect
      })
      this.centerDialogVisible = false
    },
    async cusSerBtnClick(item) {
      if (this.$store.state.loginStatus) {
        let userInfo = await apiuserInfo({action: 'verified'})
        if (userInfo.data.cert_id === '' && this.$store.state.systemInfo.real_name_auth == '1' && this.$store.state.userData.country_code == '86') {
          this.realNameShow = true
          return
        }
        this.product = item
        this.productId = item.id
        this.centerDialogVisible = true

      } else {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.game_name,
            game_id: this.game_id,
            id: this.id,
          },
        })
      }
    },
    //复制微信
    contactCusSer_copy(wechat) {
      var text = wechat;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: '复制成功'
      })
    },
    /**
     * 选择商品类型
     * @param item 商品类型选中项
     */
    productTypeClick(item) {
      this.$sensorsTrack.ProductTypeSelect(this.game_name, this.game_id, item.name, item.id)
      this.currentPage = 1
      this.productTypeSelect = item.id
      localStorage.setItem('productTypeSelect', item.id)
      this.matchCon = ''
      this.filterForm = {}
      this.gameListData = []
      switch (item.id) {
        case 1:
          this.getProductCategory(this.game_id)
          break;
        case 2:
          this.getEquipCategory(this.game_id)
          break;
        case 3:
          this.getGoldCategory(this.game_id)
          break;
      }
      this.getList();
    },
    /**
     * 分页
     */
    handleCurrentChange(val) {
      this.currentPage = val
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.getList();
    },
    /**
     * 获取 游戏账号 筛选表单数据
     * @param game_id  游戏id
     */
    getProductCategory(game_id) {
      this.filterData = []
      this.filterOptions = []
      this.filterRanges = []
      this.loadMultilevel(game_id)
      // 王者用盼之多层级面板替代皮肤数量(个)等区间，避免重复 + 老布局(iteration#1 已否决这几个区间)
      const isWzryMl = String(game_id) === '10013' || this.game_name === '王者荣耀'
      apiProductCategory({
        game_id: game_id
      }).then(res => {
        res.data.forEach(item => {
          //区间维度(value_type=RANGE)：分流到 filterRanges，按元数据(facet_key/unit)数据驱动渲染
          if (item.value_type === 'RANGE' && item.facet_key) {
            if (isWzryMl) return  // 王者：皮肤数量区间由多层级"稀有皮肤/英雄全皮/星元套装"等承接
            this.filterRanges.push(item)
            this.$set(this.scopeValue, 'min_' + item.facet_key, '')
            this.$set(this.scopeValue, 'max_' + item.facet_key, '')
            return
          }
          if (item.is_gaoji === 1) {
            if (item.haveAttr) {
              item.foreverEntries = item.entries.length > 0 ? true : false
              this.filterOptions.push(item)
              this.$set(this.filterForm, item.cat_id, 0)
            } else {
              item.entries.forEach(entriesItem => {
                this.$set(this.filterForm, entriesItem.cat_id, 0)
              })
              if (this.filterGrouping.length != 0) {
                if (this.filterGrouping[0].game_id == game_id) {
                  for (let k of this.filterGrouping) {
                    if (item.cat_id == k.cat_id) {
                      return
                    }
                  }
                } else {
                  this.filterGrouping = []
                }
              }
              item.game_id = game_id
              this.filterGrouping.push(item)
            }
            item.show = item.entries.length > 0 ? true : false
          } else {
            this.filterData.push(item)
            this.$set(this.filterForm, item.cat_id, 0)
          }
        })
      })
    },
    /**
     * 盼之多层级筛选：加载树(独立面板，王者) + 下钻交互
     */
    loadMultilevel(game_id) {
      this.mlDims = []
      this.mlSel = {}
      if (String(game_id) !== '10013' && this.game_name !== '王者荣耀') return
      const buildDims = (tree) => {
        const idx = {}
        const walk = (nodes) => (nodes || []).forEach(n => { idx[n.code] = n; if (n.children) walk(n.children) })
        walk(tree || [])
        const dims = []
        const pushKids = code => { const g = idx[code]; if (g && g.children) g.children.forEach(c => dims.push(c)) }
        const pushNode = code => { if (idx[code]) dims.push(idx[code]) }
        pushKids('pzds:attr')           // 贵族/国标/稀有皮肤/账号特色
        pushNode('pzds:roles')          // 英雄分路(角色→英雄→皮肤)
        pushKids('pzds:skinsets')       // 英雄全皮/星元套装
        pushKids('pzds:limited')        // 战令限定/局内装扮…
        pushNode('pzds:limited_series') // 限定套系
        pushNode('pzds:rare_hero')      // 稀有英雄
        pushNode('pzds:lianti_game')    // 连体游戏
        pushNode('pzds:keyword')        // 关键词特色
        // P1/P2：仅渲染后端已接线的维度（资产类 + 贵族 + 段位），避免"可点不生效"。
        // 其余账号级维度（账号特色/限定套系/连体/关键词/英雄全皮/稀有皮肤/战令）随后端逐步接线再开放。
        const WIRED = ['pzds:guobiao', 'pzds:roles', 'pzds:junei', 'pzds:rare_hero', 'pzds:xingyuan', 'pzds:nobility', 'pzds:rank']
        this.mlDims = dims.filter(n => n && n.children && n.children.length && WIRED.indexOf(n.code) !== -1)
      }
      // 优先真实接口；未部署/失败时回落静态 JSON，保证本地与过渡期可用
      apiProductMultilevel({ game_id: game_id }).then(res => {
        const tree = (res && res.data && res.data.tree) || []
        if (!tree.length) throw new Error('empty')
        buildDims(tree)
      }).catch(() => {
        fetch('/wzry_multilevel.json').then(r => r.json()).then(d => buildDims(d.tree || [])).catch(() => {})
      })
    },
    mlToggle(leaf) {
      if (this.mlSel[leaf.code]) this.$delete(this.mlSel, leaf.code)
      else this.$set(this.mlSel, leaf.code, leaf)   // 存节点(含 name)，供组装筛选参数
      this.currentPage = 1
      this.getList()
    },
    // 多级选中 → 列表筛选参数(国标先行：发选中叶子 code，后端按 dd_accuprice_taxonomy_tree 解析)
    mlParam() {
      // 国标走后端高精度路径(category+英雄)；其余维度按所属维度分组(组内 OR、组间 AND)，
      // 后端用 taxonomy.meta.facet.term 匹配采集资产。维度 = 选中叶子所在的顶层 ml-dim。
      const guobiao = []
      const groups = {}
      const dimOf = (code) => {
        for (const dim of this.mlDims) {
          let hit = false
          const walk = n => { if (!n || hit) return; if (n.code === code) { hit = true; return } (n.children || []).forEach(walk) }
          walk(dim)
          if (hit) return dim.code
        }
        return 'misc'
      }
      Object.keys(this.mlSel).forEach(code => {
        if (code.indexOf('pzds:guobiao:') === 0) { guobiao.push(code); return }
        const d = dimOf(code)
          ; (groups[d] = groups[d] || []).push(code)
      })
      const ml = {}
      if (guobiao.length) ml.guobiao = guobiao
      if (Object.keys(groups).length) ml.groups = groups
      return Object.keys(ml).length ? JSON.stringify(ml) : ''
    },
    /**
     * 获取 游戏金币 筛选表单数据
     * @param game_id 游戏id
     */
    getGoldCategory(game_id) {
      this.filterData = []
      this.filterOptions = []
      apiGoldCategory({
        game_id: game_id
      }).then(res => {
        res.data.forEach(item => {
          if (item.is_gaoji === 1) {
            if (item.haveAttr) {
              item.foreverEntries = item.entries.length > 0 ? true : false
              this.filterOptions.push(item)
              this.$set(this.filterForm, item.cat_id, 0)
            } else {
              this.filterGrouping.push(item)
              item.entries.forEach(entriesItem => {
                this.$set(this.filterForm, entriesItem.cat_id, 0)
              })
            }
          } else {
            this.filterData.push(item)
            this.$set(this.filterForm, item.cat_id, 0)
          }
        })
      })
    },
    /**
     * 获取 游戏装备 筛选表单数据
     * @param game_id 游戏id
     */
    getEquipCategory(game_id) {
      this.filterData = []
      this.filterOptions = []
      apiEquipCategory({
        game_id: game_id
      }).then(res => {
        res.data.forEach(item => {
          if (item.is_gaoji === 1) {
            if (item.haveAttr) {
              if (item.entries.length === 0) {
                item.show = false
              }
              item.foreverEntries = item.entries.length > 0 ? true : false
              this.filterOptions.push(item)
              this.$set(this.filterForm, item.cat_id, 0)
            } else {
              this.filterGrouping.push(item)
              item.entries.forEach(entriesItem => {
                this.$set(this.filterForm, entriesItem.cat_id, 0)
              })
            }
            item.show = item.entries.length > 0 ? true : false
          } else {
            this.filterData.push(item)
            this.$set(this.filterForm, item.cat_id, 0)
          }
        })
      })
    },

    /**
     * 游戏筛选 单选
     * @param item   选中列
     * @param items  选中列的项
     */
    async filterItemClick(item, items) {
      this.$sensorsTrack.NormalScreen(
        this.game_name,
        this.game_id,
        this.productType[this.productType.findIndex(v => v.id == this.productTypeSelect)].name,
        this.productTypeSelect,
        item.cat_name,
        items.name,
      )
      if (items.haveChild) {
        switch (this.productTypeSelect) {
          case 1:
            await apiProductPcate({
              game_id: this.game_id,
              pid: items.id
            }).then(res => {
              this.filterOptions.forEach((Oitems, Oindexs) => {
                if (Oitems.parent_id == item.cat_id) {
                  Oitems.show = false
                  Oitems.entries = []
                }
              })
              for (let resKey in res.data.list) {
                this.filterData.forEach((Ditems, Dindexs) => {
                  if (Ditems.cat_id === parseInt(resKey)) {
                    Ditems.entries.splice(1, Ditems.entries.length)
                    res.data.list[resKey].forEach((keyItem, keyIndex) => {
                      Ditems.entries.push(keyItem)
                    })
                  }
                })
                this.filterOptions.forEach((Oitems, Oindexs) => {
                  if (Oitems.cat_id === parseInt(resKey)) {
                    Oitems.show = true
                    res.data.list[resKey].forEach((keyItem, keyIndex) => {
                      Oitems.entries.push(keyItem)
                    })
                  }
                  if (Oitems.is_gaoji == 1 && !Oitems.show) {
                    this.filterForm[Oitems.cat_id] = []
                  }
                })
              }
              for (let key in this.filterForm) {
                for (const keyKey in res.data.list) {
                  if (key == keyKey) {
                    if (Array.isArray(this.filterForm[key])) {
                      this.filterForm[key] = []
                    } else {
                      this.filterForm[key] = 0
                    }
                  }
                }
              }
            })
            break;
          case 2:
            await apiEquipAttr({
              game_id: this.game_id,
              pid: items.id
            }).then(res => {
              this.filterOptions.forEach((Oitems, Oindexs) => {
                if (Oitems.parent_id == item.cat_id) {
                  Oitems.show = false
                  Oitems.entries = []
                }
              })
              for (let resKey in res.data.list) {
                this.filterData.forEach((Ditems, Dindexs) => {
                  if (Ditems.cat_id === parseInt(resKey)) {
                    Ditems.entries.splice(1, Ditems.entries.length)
                    res.data.list[resKey].forEach((keyItem, keyIndex) => {
                      Ditems.entries.push(keyItem)
                    })
                  }
                })
                this.filterOptions.forEach((Oitems, Oindexs) => {
                  if (Oitems.cat_id === parseInt(resKey)) {
                    Oitems.show = true
                    res.data.list[resKey].forEach((keyItem, keyIndex) => {
                      Oitems.entries.push(keyItem)
                    })
                  }
                  if (Oitems.is_gaoji == 1 && !Oitems.show) {
                    this.filterForm[Oitems.cat_id] = []
                  }
                })
              }
              for (let key in this.filterForm) {
                for (const keyKey in res.data.list) {
                  if (key == keyKey) {
                    if (Array.isArray(this.filterForm[key])) {
                      this.filterForm[key] = []
                    } else {
                      this.filterForm[key] = 0
                    }
                  }
                }
              }
            })
            break;
          case 3:
            await apiGoldAttr({
              game_id: this.game_id,
              pid: items.id
            }).then(res => {
              for (let resKey in res.data.list) {
                this.filterData.forEach((Ditems, Dindexs) => {
                  if (Ditems.cat_id === parseInt(resKey)) {
                    Ditems.entries.splice(1, Ditems.entries.length)
                    res.data.list[resKey].forEach((keyItem, keyIndex) => {
                      Ditems.entries.push(keyItem)
                    })
                  }
                })
              }
              for (let key in this.filterForm) {
                for (const keyKey in res.data.list) {
                  if (key == keyKey) {
                    this.filterForm[key] = 0
                  }
                }
              }
            })
            break;
        }
      } else {
        this.filterData.forEach((Ditems, Dindexs) => {
          if (Ditems.parent_id === item.cat_id) {
            Ditems.entries.splice(1, Ditems.entries.length)
            this.filterForm[Ditems.cat_id] = 0
          }
        })
        // if (this.productTypeSelect === 2) {
        this.filterOptions.forEach((Oitems, Oindexs) => {
          if ((!Oitems.foreverEntries && Oitems.parent_id == item.cat_id)) {
            Oitems.show = false
            Oitems.entries = []
          }
        })
        // }
        // if (item.haveChild) {
        //   this.filterOptions.forEach((Oitems, Oindexs) => {
        //     Oitems.show = false
        //     Oitems.entries = []
        //   })
        // }
      }

      if (item.unique_id === 'ajg') {
        this.scopeValue.max_price = ''
        this.scopeValue.min_price = ''
      }
      this.currentPage = 1
      this.getList();
    },
    /**
     * 清空所有选项
     */
    emptyOptions() {
      for (let key in this.filterForm) {
        this.filterForm[key] = 0;
      }
      this.filterData.forEach((item, index) => {
        if (item.parent_id === 1) {
          this.filterData[index].entries.splice(0, this.filterData[1].entries.length)
          let entries = new Object()
          entries.id = 0
          entries.name = '全部'
          this.filterData[index].entries.push(entries)
        }
      })
      for (let scopeValueKey in this.scopeValue) {
        this.scopeValue[scopeValueKey] = ''
      }
      this.currentPage = 1
      this.getList();
    },
    /**
     * 排序 点击事件
     * @param item 所点击项
     */
    clickSortItem(item) {
      if (this.sortItemIndex === item.type) {
        if (this.sortItemMethod === 1) {
          this.sortItemMethod = 2
        } else {
          this.sortItemMethod = 1
        }
      } else {
        this.sortItemIndex = item.type
        this.sortItemMethod = 2
      }
      this.currentPage = 1
      this.getList();
    },
    /**
     * 筛选 点击
     */
    scopeValueClick() {
      if (this.scopeValue.max_price !== '' || this.scopeValue.min_price !== '') {
        this.$sensorsTrack.PriceScreen(
          this.game_name,
          this.game_id,
          this.productType[this.productType.findIndex(v => v.id == this.productTypeSelect)].name,
          this.productTypeSelect,
          this.scopeValue.max_price,
          this.scopeValue.min_price,
        )
      }
      if (this.validScopeValue()) {
        this.currentPage = 1
        this.getList();
      }
    },
    /**
     * 诚心卖-神策埋点
     */
    SellSincereScreen(val) {
      this.$sensorsTrack.SellSincereScreen(
        this.game_name,
        this.game_id,
        this.productType[this.productType.findIndex(v => v.id == this.productTypeSelect)].name,
        this.productTypeSelect,
        val == 'all' ? '全部' : val == '1' ? '已购买' : val == '0' ? '未购买' : ''
      )
      this.scopeValueClick()
    },
    validScopeValue() { // 验证筛选值规则
      const {min_server, max_server, min_v_number, max_v_number} = this.scopeValue

      const reg = /^[1-9]\d{0,3}$/ // 1-9999

      if (['32', '159'].includes(`${this.game_id}`)) {
        if (min_server && !reg.test(min_server) || max_server && !reg.test(max_server)) {
          this.$message.warning('区服请输入1-9999')
          return false;
        } else if ((min_server && max_server) && (Number(min_server) > Number(max_server))) {
          this.$message.warning('第二项输入框数字内容不能低于第一项输入框')
          return false;
        }
      } else if (['39'].includes(`${this.game_id}`)) {
        if (min_v_number && !reg.test(min_v_number) || max_v_number && !reg.test(max_v_number)) {
          this.$message.warning('V数量请输入1-9999')
          return false;
        } else if ((min_v_number && max_v_number) && (Number(min_v_number) > Number(max_v_number))) {
          this.$message.warning('第二项输入框数字内容不能低于第一项输入框')
          return false;
        }
      }
      return true
    },
    /**
     * 账号列表 数据点击
     * @param item 所点击项
     */
    clickGameListItem(item) {
      let routeUrl = this.$router.resolve({
        name: 'GameDetails',
        query: {
          game_id: this.game_id,
          id: item.id,
          source_page: this.$route.path.slice(1)
        },
      });
      window.open(routeUrl.href, '_blank');
    },
    //高级选项 下拉框监听事件
    optionSelect(val, item, Eitem, type) {
      this.$sensorsTrack.AdvancedScreen(
        this.game_name,
        this.game_id,
        this.productType[this.productType.findIndex(v => v.id == this.productTypeSelect)].name,
        this.productTypeSelect,
        type == 'filterGrouping' ? `${item.cat_name},${Eitem.cat_name}` : item.cat_name,
        type == 'filterGrouping' ?
          item.entries[item.entries.indexOf(Eitem)].entries[Eitem.entries.findIndex(v => v.id == val[val.length - 1])].name :
          item.entries[item.entries.findIndex(v => v.id == val[val.length - 1])].name,
      )
      this.currentPage = 1
      this.getList();
    },
    /**
     * 获取 游戏账号列表
     */
    getProductList() {
      apiProductList({
        game_id: this.game_id,
        rec: this.rec,
        category: this.filterForm,
        scope: this.scopeValue,
        multilevel: this.mlParam(),
        matchCon: this.matchCon,
        services: this.services,
        sort: {
          type: this.sortItemIndex,
          method: this.sortItemMethod,
        },
        page: this.currentPage
      }).then(res => {
        this.game_name = res.data.game.game_name
        this.is_renewal = res.data.game.is_renewal
        this.game_class = res.data.game.game_class
        this.game_customer = res.data.game.game_customer
        this.productType = res.data.game.game_service
        this.game_image = res.data.game.game_image
        this.buy_group = res.data.game.buy_group
        this.is_open_trans_chat = res.data.game.is_open_trans_chat
        this.gameListData = res.data.list
        this.totalCount = res.data.total
        this.PageSize = res.data.pageSize
        this.currentPage = res.data.page
        // document.title = `${this.seo_keyword}${this.game_name} — 游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护`
        document.title = `${this.seo_keyword}${this.game_name} — 游严选账号服务网-签署合同让交易享受法律保护`
      }).finally(() => {
        this.loading = false
      })
    },
    /**
     * 获取 游戏装备列表
     */
    getEquipList() {
      apiEquipList({
        game_id: this.game_id,
        category: this.filterForm,
        scope: this.scopeValue,
        sort: {
          type: this.sortItemIndex,
          method: this.sortItemMethod,
        },
        matchCon: this.matchCon,
        page: this.currentPage
      }).then(res => {
        this.game_name = res.data.game.game_name
        this.game_class = res.data.game.game_class
        this.game_customer = res.data.game.game_customer
        this.productType = res.data.game.game_service
        this.game_image = res.data.game.game_image
        this.gameListData = res.data.list
        this.totalCount = res.data.total
        this.PageSize = res.data.pageSize
        this.currentPage = res.data.page
        this.yesterdayDeal = res.data.yesterdayDeal
        // document.title = `${this.seo_keyword}${this.game_name} — 游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护`
        document.title = `${this.seo_keyword}${this.game_name} — 游严选账号服务网-签署合同让交易享受法律保护`
      }).finally(() => {
        this.loading = false
      })
    },
    /**
     * 获取 游戏金币列表
     */
    getGoldList() {
      apiGoldList({
        game_id: this.game_id,
        category: this.filterForm,
        scope: this.scopeValue,
        sort: {
          type: this.sortItemIndex,
          method: this.sortItemMethod,
        },
        page: this.currentPage
      }).then(res => {
        this.game_name = res.data.game.game_name
        this.game_class = res.data.game.game_class
        this.game_customer = res.data.game.game_customer
        this.productType = res.data.game.game_service
        this.game_image = res.data.game.game_image
        this.gameListData = res.data.list
        this.totalCount = res.data.total
        this.PageSize = res.data.pageSize
        this.currentPage = res.data.page
        // document.title = `${this.seo_keyword}${this.game_name} — 游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护`
        document.title = `${this.seo_keyword}${this.game_name} — 游严选账号服务网-签署合同让交易享受法律保护`
      }).finally(() => {
        this.loading = false
      })
    },
    /**
     * 获取 列表数据
     */
    getList() {
      this.loading = true
      switch (this.productTypeSelect) {
        case 1:
          this.getProductList();
          break;
        case 2:
          this.getEquipList();
          break;
        case 3:
          this.getGoldList();
          break;
      }
    },
    onLoad() {
      this.getList()
      switch (this.productTypeSelect) {
        case 1:
          this.getProductCategory(this.game_id)
          break;
        case 2:
          this.getEquipCategory(this.game_id)
          break;
        case 3:
          this.getGoldCategory(this.game_id)
          break;
      }
    },

    /**
     * 仅显示顶级账号
     */
    topChange(e) {
      this.$sensorsTrack.TopAccScreen(
        this.game_name,
        this.game_id,
        this.productType[this.productType.findIndex(v => v.id == this.productTypeSelect)].name,
        this.productTypeSelect,
        this.topAccShow
      )
      if (e) {
        this.rec = 'dingji'
      } else {
        this.rec = ''
      }
      this.getProductList()
    },

    //搜索
    searchSubmit() {
      this.showRecommend = false
      document.getElementById('search_input').blur()
      this.scopeValueClick()
    },
    //点击推荐结果
    clickRecommend(item) {
      if (item.game_id == '0') {
        this.value = ''
      } else {
        this.value = item.game_id * 1
      }
      this.matchCon = item.keyword
      this.searchSubmit()
    },
    //监听按键
    inputKeyDown(e) {
      if (e.code === 'ArrowDown') {
        if (this.recommendIndex === this.recommendList.length - 1) {
          this.recommendIndex = 0
        } else {
          this.recommendIndex++
        }
        this.matchCon = this.recommendList[this.recommendIndex].keyword
      } else if (e.code === 'ArrowUp') {
        if (this.recommendIndex === 0) {
          this.recommendIndex = this.recommendList.length - 1
        } else {
          this.recommendIndex--
        }
        this.matchCon = this.recommendList[this.recommendIndex].keyword
      }
    },
    //输入文本时获取推荐结果
    handleInput() {
      setTimeout(() => {
        if (this.flag) {
          if (this.setTimeOut) {
            clearTimeout(this.setTimeOut)
          }
          if (this.matchCon === '') {
            this.recommendList = []
            return
          }
          this.setTimeOut = setTimeout(() => {
            searchParticiple({
              game_id: this.game_id,
              match: this.matchCon
            }).then(res => {
              this.recommendList = res.data
            })
          }, 100)
        }
      }, 0)
    },

    /**
     * 账号点击 - 神策埋点
     * @param item
     * @param index
     * @constructor
     */
    AccountClick(item, index) {
      const query = this.$route.query
      if (Object.keys(query).includes('matchCon')) {
        this.$sensorsTrack.SearchResultClick(
          query.matchCon,
          this.game_name,
          this.game_id,
          `${this.gameInfo.game_alias}_${item.id}`,
          index + 1,
        )
      }
      this.$sensorsTrack.AccountClick(
        this.$route.name,
        this.currentPage,
        `${this.gameInfo.game_alias}_${item.id}`,
        this.game_name,
        this.game_id,
        item.user_id,
        '',
        index + 1,
        `${this.gameInfo.game_alias}_${item.id}`,
        '游戏账号',
        '',
        '',
        '',
        '',
        '',
      )
    }
  },
  async created() {
    await apiGameInfo({
      id: this.$route.query.game_id
    }).then(res => {
      this.gameInfo = res.data
      this.sys_service_type = res.data.sys_service_type
      let product_type = ''
      if (res.data.game_service.findIndex(v => v.id == this.productTypeSelect) > -1) {
        product_type = res.data.game_service[res.data.game_service.findIndex(v => v.id == this.productTypeSelect)].name
      }
      this.$sensorsTrack.ProductTypeSelect(res.data.game_name, this.game_id, product_type, this.productTypeSelect)
      this.seo_keyword = res.data.seo_keyword
    })
    document.title = ''
    if (localStorage.getItem('productTypeSelect')) {
      this.productTypeSelect = localStorage.getItem('productTypeSelect') * 1
    }
    if (this.$route.params.productTypeSelect) {
      this.productTypeSelect = this.$route.params.productTypeSelect
    }

    switch (this.productTypeSelect) {
      case 1:
        this.getProductCategory(this.$route.query.game_id)
        break;
      case 2:
        this.getEquipCategory(this.$route.query.game_id)
        break;
      case 3:
        this.getGoldCategory(this.$route.query.game_id)
        break;
      default:
        this.getProductCategory(this.$route.query.game_id)
        break;
    }
    // this.getProductCategory(this.$route.query.game_id)
    if (this.$route.params.type) {
      this.sortItemIndex = 'isnew',
        //排序方式 0不筛选(默认) 1降序 2升序
        this.sortItemMethod = 1
    }
    if (this.$route.query.game_id == 8) {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '功力', type: 'gonglisort'},
        {name: '魅力', type: 'meilisort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_gongli: '',
        max_gongli: '',
        min_meili: '',
        max_meili: '',
      }
    } else if (this.$route.query.game_id == 13) {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '皮肤数量', type: 'skinsort'},
        {name: '贵族等级', type: 'skinsort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_skin: '',
        max_skin: '',
        min_level: '',
        max_level: '',
        min_legend: '',
        max_legend: '',
        min_epic: '',
        max_epic: '',
      }
    } else if (this.$route.query.game_id == 12) {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '皮肤数量', type: 'skinsort'},
        {name: '英雄数量', type: 'herosort'},
        {name: '账号等级', type: 'productlevelsort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_skin: '',
        max_skin: '',
        min_hero: '',
        max_hero: '',
      }
    } else if (this.$route.query.game_id == 26 || this.$route.query.game_id == 161) {
      this.$route.query.game_id == 26
        ?
        this.sortItem = [
          {name: '综合排序', type: ''},
          {name: '时间', type: 'isnew'},
          {name: '价格', type: 'pricesort'},
          {name: '热度', type: 'redusort'},
          {name: '黄数', type: 'yellowsort'},
        ]
        :
        this.sortItem = [
          {name: '综合排序', type: ''},
          {name: '时间', type: 'isnew'},
          {name: '价格', type: 'pricesort'},
          {name: '热度', type: 'redusort'},
        ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_yellow: '',
        max_yellow: '',
      }
    } else if (this.$route.query.game_id == 11) {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_credit: '',
        max_credit: '',
        min_cars: '',
        max_cars: '',
      }
    } else if(this.$route.query.game_id == 163){
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '衣品值', type: 'clothessort'},
        {name: '总评', type: 'productlevelsort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
      }
    } else if(this.$route.query.game_id == 178){
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '道具等级', type: 'proplevelsort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
      }
    } else {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
      }
    }
    if (this.$route.params.rec) {
      this.rec = this.$route.params.rec
      if (this.rec === 'dingji') {
        this.topAccShow = true
      }
    }
    if (this.$route.params.breadCrumbs) {
      this.breadCrumbs = this.$route.params.breadCrumbs
    }
    //初始化数据
    if (this.$route.params.list) {
      this.game_id = this.$route.query.game_id
      this.game_name = this.$route.params.game_name
      this.game_class = this.$route.params.game_class
      this.matchCon = this.$route.query.matchCon
    }
    //初始化数据
    this.getList()

    //访问统计
    apiStatisticsAdd({
      game_id: this.$route.query.game_id,
      statistics_type: 1
    })

  },
  computed: {
    selectGameBreadcrumbList() {
      return [
        {name: this.breadCrumbs || '全部游戏', link: '/allGame'},
        {
          name: this.game_name || '',
          link: '/selectgame',
          query: {
            game_id: this.$route.query.game_id,
            game_alias: this.$route.query.game_id == '26' ? 'yuanshen5' : 'games'
          }
        }
      ]
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.game_id = to.query.game_id
    this.game_class = to.params.game_class
    this.game_name = to.params.game_name
    this.matchCon = to.query.matchCon
    if (this.game_id == 8) {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '功力', type: 'gonglisort'},
        {name: '魅力', type: 'meilisort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_gongli: '',
        max_gongli: '',
        min_meili: '',
        max_meili: '',
      }
    } else if (this.$route.query.game_id == 13 || this.$route.query.game_id == 12) {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
        {name: '皮肤数量', type: 'skinsort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
        min_skin: '',
        max_skin: '',
      }
    } else {
      this.sortItem = [
        {name: '综合排序', type: ''},
        {name: '时间', type: 'isnew'},
        {name: '价格', type: 'pricesort'},
        {name: '热度', type: 'redusort'},
      ]
      this.scopeValue = {
        min_price: '',
        max_price: '',
      }
    }
    this.currentPage = 1
    this.getList()
    switch (this.productTypeSelect) {
      case 1:
        this.getProductCategory(to.query.game_id)
        break;
      case 2:
        this.getEquipCategory(to.query.game_id)
        break;
      case 3:
        this.getGoldCategory(to.query.game_id)
        break;
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem('productTypeSelect', 1)
    if (to.name !== 'SelectGame') {
      document.title = '游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护'
      next()
    }
    next()
  },

}
</script>
<style lang="less">
.contactCusSer {
  width: 500px;
  background: #FFFFFF;
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  .el-dialog__body {
    padding: 10px 15px 20px;
    position: relative;

    #contactCusSer {
      width: 470px;

      .contactCusSer_title {
        background: #313131;
        color: #FFFFFF;
        text-align: center;
        border-radius: 4px;
        height: 33px;
        line-height: 33px;
        font-size: 20px;
      }

      .contactCusSer_list {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 20px 0 0 0;

        .CL_item {
          width: 450px;
          height: 26px;
          margin: 0 0 10px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          div {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #000000;
          }

          .CL_btn {
            width: 120px;
            display: flex;
            flex-direction: row;

            div, a {
              margin: 0 10px 0 0;
              font-size: 16px;
              background: #f7d969;
              width: 54px;
              height: 26px;
              line-height: 26px;
              text-align: center;
              border-radius: 4px;
              cursor: pointer;
            }

            a {
              margin: 0;
              background: #f19958;
            }

          }

          #input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            z-index: -10;
          }
        }
      }

      .onlineCus {
        margin: 20px auto;
        width: 100px;
        text-align: center;
        background-color: var(--primary, #FF5A1F);
        color: #FFFFFF;
        padding: 10px 18px;
        font-weight: bold;
        font-size: 16px;
        border-radius: 3px;
        cursor: pointer;
        user-select: none;
        display: block;
      }

      .contactCusSer_tip {
        text-align: center;
        color: black;
        margin: 4px 0 0 0;
        //font-weight: 600;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 14px;

        span {
          display: inline-block;
          color: #FF5454;
        }
      }

    }
  }

  .el-dialog__header {
    padding: 0;
  }
}
</style>
<style lang='less' scoped>

/deep/ .el-radio__input {
  display: none !important;
}

/deep/ .el-select__caret {
  font-size: 18px !important;
}

/deep/ .el-input--suffix .el-input__inner {
  height: 30px !important;
  width: 240px !important;
  line-height: 30px !important;
  font-size: 18px !important;
}

/deep/ .el-input__icon {
  line-height: 0;
}

/deep/ .el-input__inner::-webkit-input-placeholder {
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #BFBFBF;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary, #FF5A1F);
  box-shadow: none;
}

/deep/ .el-select .el-input__inner:focus {
  border-color: var(--primary, #FF5A1F);
  box-shadow: none;
}

/deep/ .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background: var(--bg-tag, #F0EDE8);
}

/deep/ .el-select-dropdown__item.selected {
  color: var(--primary, #FF5A1F) !important;
  font-weight: normal !important;
}

/deep/ .el-pagination {
  font-weight: 400;
  font-family: PingFangSC-Light, PingFang SC;
}

/deep/ .el-pager li.active,
/deep/ .el-pager li:hover,
/deep/ .el-pagination button:hover {
  color: var(--primary, #FF5A1F) !important;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--primary, #FF5A1F);
  color: #FFFFFF !important;
  border-radius: 3px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: var(--primary, #FF5A1F);
}

/deep/ .el-select-dropdown el-popper {
  min-width: 224px;
  left: 146px;
}

/deep/ .el-select-dropdown__item /deep/ .selected {
  color: var(--primary, #FF5A1F) !important;
}

/deep/ *.popper__arrow {
  left: 345px !important;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--primary, #FF5A1F);
  border-color: var(--primary, #FF5A1F) !important;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--primary, #FF5A1F) !important;
}

/deep/ .el-checkbox__inner:hover {
  border-color: var(--primary, #FF5A1F) !important;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--primary, #FF5A1F);
}

/deep/ .el-checkbox__label {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #8f8f8f;
  line-height: 14px;
}


.all_game {
  width: 1200px;
  color: var(--text-main, #111827);

  .list {
    background: var(--bg-page, #F7F5F2);

    .product_type {
      padding: 18px 28px 0;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px 4px 0 0;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      #product_type_box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        #product_type {
          display: flex;
          flex-direction: row;
          align-items: center;

          padding: 0 0 16px 0;

          .product_type_img {
            width: 72px;
            height: 72px;
            margin: 0 22px 0 0;

            img {
              border-radius: 4px;
              width: 72px;
              height: 72px;
              object-fit: cover;
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.12);
            }
          }

          .product_type_content {
            .product_type_title {
              font-size: 18px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 600;
              color: var(--text-main, #111827);
              line-height: 26px;
              margin: 0 0 8px 0;
            }

            .product_type_list {
              display: flex;
              flex-direction: row;
              //padding: 0 10px;
              .product_type_option {
                position: relative;
                z-index: 0;
                font-size: 14px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: var(--text-secondary, #5A5F6B);
                line-height: 20px;
                cursor: pointer;
                margin: 0 14px 0 0;
                padding: 7px 18px;
                border: 0;
                border-radius: 0;
                background: transparent;
                box-sizing: border-box;
                transition: color 0.2s ease;

                /* 斜切平行四边形底（文字正立） */
                &::before {
                  content: "";
                  position: absolute;
                  inset: 0;
                  background: var(--bg-tag, #F0EDE8);
                  transform: skewX(-12deg);
                  border-radius: 2px;
                  z-index: -1;
                  transition: background 0.2s ease;
                }

                &:hover {
                  color: var(--primary, #FF5A1F);
                  background: transparent;
                }

                &:hover::before {
                  background: var(--border-soft, #E8E4DE);
                }
              }

              .product_type_select {
                padding: 7px 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                background: transparent;
                box-shadow: none;

                &::before {
                  background: var(--primary, #FF5A1F);
                  box-shadow: 0 8px 18px rgba(255, 90, 31, 0.22);
                }

                /* 底部能量条（炭色，三件套之一） */
                &::after {
                  content: "";
                  position: absolute;
                  left: 0;
                  bottom: -3px;
                  width: 100%;
                  height: 3px;
                  background: var(--bg-dark, #1A1D24);
                  z-index: 1;
                }

                &:hover {
                  color: #FFFFFF;
                }

                &:hover::before {
                  background: var(--primary-hover, #E84A12);
                }
              }

              .product_type_option:last-of-type {
                margin: 0;
              }
            }
          }
        }

        .otherBusiness {
          display: flex;
          align-items: center;

          .otherBusiness_item {
            margin: 0 0 0 22px;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
            position: relative;
            color: var(--text-secondary, #5A5F6B) !important;

            &:hover {
              color: var(--brand-blue, #1A1D24) !important;
            }

            .otherBusiness_tag {
              position: absolute;
              top: -15px;
              right: -15px;
            }
          }
        }
      }


    }

    .filter {
      background: var(--bg-card, #FFFFFF);
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: 1px solid var(--border-soft, #E8E4DE);
      border-top: none;
      border-radius: 0 0 4px 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      .yesterdayDeal {
        margin: 20px 40px 0;
        display: flex;
        flex-direction: row;
        align-items: center;

        .YD_num {
          margin: 0 30px 0 0;
          width: 100px;
          height: 22px;
          padding: 0 11px;
          background: url("../../../assets/image/AllGame/yesterdayDeal.png") no-repeat;
          background-size: 100% 100%;
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          text-align: center;
        }

        .YD_checkInfo {
          font-size: 12px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 300;
          color: var(--text-secondary, #5A5F6B);
          line-height: 17px;
          cursor: pointer;
        }

        .YD_checkInfo:hover {
          color: var(--brand-blue, #1A1D24);
        }
      }

      .filter_ground {
        margin: 20px 28px 22px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        div {
          //margin-bottom: 20px;
        }

        .gaming_zone, .server, .profession, .equipment {
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
          margin: 0 0 12px 0;
          min-height: 34px;

          div {
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            float: left;
            line-height: 28px;
          }

          ul {
            width: 1020px;
            float: right;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            /* 统一为现代 chip：白底+1px细边+3px紧角，隐藏单选点；遵循 DESIGN-new.md */
            /deep/ .el-radio {
              display: inline-flex;
              align-items: center;
              height: 30px;
              margin: 0 8px 8px 0;
              padding: 0 12px;
              background: #fff;
              border: 1px solid var(--border-soft, #E8E4DE);
              border-radius: 3px;
              transition: all .2s cubic-bezier(.22, .9, .24, 1);

              &:hover {
                border-color: var(--primary, #FF5A1F);
                .el-radio__label { color: var(--primary, #FF5A1F); }
              }
            }

            /deep/ .el-radio__input { display: none; }

            /deep/ .el-radio.is-checked {
              background: var(--primary, #FF5A1F);
              border-color: var(--primary, #FF5A1F);

              .el-radio__label {
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
              }
            }

            /deep/ .el-radio__label {
              text-align: center;
              font-size: 13px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              cursor: pointer;
              padding: 0;
              line-height: 1;
            }

            span {

            }
          }

          .gaming_zone_select {
            text-align: center;
            display: inline-block;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            background-color: var(--primary, #FF5A1F);
            border-radius: 4px;
            padding: 0 20px;
            margin: 8px;
            line-height: 35px;
          }
        }

        /* 盼之多层级筛选(独立面板)：维度行 = 左标签 + 右递归内容(MlBranch) */
        .ml-dim {
          display: flex;
          align-items: flex-start;
          padding: 12px 0;
          border-bottom: 1px solid var(--border-soft, #E8E4DE);

          .ml-label {
            flex: 0 0 92px;
            padding-right: 10px;
            font-size: 14px;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 30px;
            text-align: left;
          }
          .ml-body {
            flex: 1;
            min-width: 0;
          }
        }

        .is_gaoji {
          border: none;
          margin-bottom: 10px;

          .is_gaoji_title {
            margin: 5px 0;
          }

          ul {
            .is_gaoji_select {
              display: flex;
              align-items: center;
              width: 33.33%;
              margin: 0 0 15px 0;

              .optionsLable {
                max-width: 90px;
                min-width: 50px;
                margin-right: 10px;
                font-size: 14px;
	                font-family: PingFangSC-Regular, PingFang SC;
	                font-weight: 400;
	                color: var(--text-secondary, #5A5F6B);
	                overflow: hidden;
	                text-overflow: ellipsis;
	                white-space: nowrap;
              }
            }
          }
        }

        .advanced_options {
          margin: 0;

          .advanced_options_title {
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            float: left;
            margin: 20px 0;
          }

          .select_box {
            width: 1010px;
            float: right;
            padding: 0 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            margin: 0;

            .select_box_title {
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              margin-right: 10px;
            }

            div {
              margin-right: 25px;
            }
          }
        }

        .price {
          border-top: 1px solid var(--border-soft, #E8E4DE);
          padding-top: 16px;
          // height: 40px;
          line-height: 34px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          //justify-content: space-between;
          .price_price, .power_value, .charm_value, .skin_value, .hero_value, .area_value, .v_number_value {
            display: flex;
            align-items: center;
            height: 34px;
            margin: 0 0 10px 28px;

            div:first-of-type {
              margin: 0;
              margin-right: 10px;
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
            }

            .min_price, .max_price {
              display: flex;
              width: 76px;
              height: 30px;
              background: #fff;
              border-radius: 3px;
              font-size: 13px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              color: var(--text-main, #111827);
              line-height: 30px;
              text-align: center;
              border: 1px solid var(--border-soft, #E8E4DE);
              padding: 0 4px 0 10px;
              box-sizing: border-box;
              outline: none;

            }

            .min_price:focus, .max_price:focus {
              border-color: var(--primary, #FF5A1F);
              box-shadow: none;
            }

            .min_price[type="number"], .max_price[type="number"] {
              padding-right: 0;
            }

            .min_price[type="number"]::-webkit-inner-spin-button,
            .max_price[type="number"]::-webkit-inner-spin-button,
            .min_price[type="number"]::-webkit-outer-spin-button,
            .max_price[type="number"]::-webkit-outer-spin-button {
              margin: 0;
            }

            .min_price::-webkit-input-placeholder, .max_price::-webkit-input-placeholder {
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              color: var(--text-muted, #9AA0AC);
              line-height: 22px;
            }

            .scope {
              margin: 0 10px;
              color: #979797;
            }
          }

          .price_price {
            margin: 0;
          }

          .price_filter {
            width: 76px;
            height: 32px;
            line-height: 32px;
            background: var(--primary, #FF5A1F);
            border-radius: 3px;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            margin: 0 0 10px 20px;
            cursor: pointer;
            box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
            transition: background 0.2s ease, box-shadow 0.2s ease;
            user-select: none;
          }

          .price_filter:hover {
            background: var(--primary-hover, #E84A12);
            box-shadow: 0 12px 24px rgba(255, 90, 31, 0.3);
          }
        }

        .matchSearch {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin: 0 0 14px;
          position: relative;

          div {
            width: 120px;
            white-space: nowrap;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
          }

          .searchInputWrap {
            width: 288px;
            height: 36px;
            position: relative;
            flex: 0 0 auto;
          }

          .searchInput {
            width: 276px;

            /deep/ .el-input__inner {
              padding-right: 64px !important;
              width: 276px !important;
              height: 36px !important;
              border: 1px solid var(--border-soft, #E8E4DE);
              border-radius: 4px;
              font-size: 14px !important;
              font-family: PingFang SC, PingFang SC-Light;
              font-weight: 300;
              text-align: LEFT;
              color: var(--text-main, #111827);

            }

            /deep/ .el-input__inner:focus {
              border-color: var(--primary, #FF5A1F);
              box-shadow: none;
            }

            /deep/ .el-input__suffix {
              right: 38px;
              top: 0;
              height: 36px;
              display: inline-flex;
              align-items: center;
              justify-content: flex-end;
            }

            /deep/ .el-input__suffix-inner {
              height: 36px;
              display: inline-flex;
              align-items: center;
            }

            /deep/ .el-input__clear {
              height: 36px;
              line-height: 36px;
              color: var(--text-muted, #9AA0AC);

              &:hover {
                color: var(--brand-blue, #1A1D24);
              }
            }
          }

          .searchButton {
            position: absolute;
            top: 4px;
            right: 16px;
            width: 28px;
            height: 28px;
            padding: 0;
            border: none;
            border-radius: 4px;
            background: transparent;
            color: var(--brand-blue, #1A1D24);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background 0.2s ease, color 0.2s ease;

            i {
              font-size: 18px;
              line-height: 1;
            }

            &:hover {
              color: var(--brand-blue, #1A1D24);
              background: var(--brand-blue-light, #F0EDE8);
            }
          }

          .search_recommend {
            padding-top: 8px;
            padding-bottom: 16px;
            position: absolute;
            top: 56px;
            left: 130px;
            z-index: 999;
            width: 347px;
            max-height: 40vh;
            background: #ffffff;
            border-radius: 4px;
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.20);
            overflow-y: auto;

            > .item {
              width: auto;
              line-height: 20px;
              padding: 9px 21px;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: #8f8f8f;
              cursor: pointer;
              display: flex;
              justify-content: space-between;

              .itemTip {
                font-size: 12px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: #8f8f8f;
              }

              &:hover {
                background: #fffcf3;
              }

              &.active {
                background: #fffcf3;
              }
            }

            .historyDel {
              padding: 0 21px;
              display: flex;
              align-items: center;
              justify-content: right;
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: #8f8f8f;

              span {
                cursor: pointer;
              }

              span:hover {
                color: #fcac10;
              }
            }
          }
        }

        .sellSincerity {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 10px;

          .sellSincerity-ttile {
            width: 120px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
          }

          /deep/ .el-input__inner {
            width: 175px !important;
            height: 34px !important;
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            font-size: 14px !important;
            font-family: PingFang SC, PingFang SC-Light;
            font-weight: 300;
            text-align: LEFT;
            color: var(--text-main, #111827);
          }

          /deep/ .el-input__inner:focus {
            border-color: var(--primary, #FF5A1F);
            box-shadow: none;
          }
        }
      }
    }

    .search {
      margin: 12px 0;
      min-height: 50px;
      border-radius: 4px;
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 28px;

      .search_left {
        display: flex;
        align-items: center;

        .sort {
          margin-right: 32px;
          position: relative;
          font-size: 14px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          cursor: pointer;
          transition: color 0.2s ease;

          &:hover {
            color: var(--brand-blue, #1A1D24);
          }

          i {
            position: absolute;
            left: 100%;
          }

          .el-icon-caret-top {
            top: 0px;
          }

          .el-icon-caret-bottom {
            top: 7px;

          }
        }

        .sort_checked {
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            color: var(--primary, #FF5A1F);
          }

          .sort1, .sort2 {
            color: var(--primary, #FF5A1F);
          }
        }
      }

      .search_mid {
        position: relative;
        margin-right: 40px;

        input {
          width: 220px;
          height: 36px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
          padding: 0 46px 0 14px;
          font-size: 14px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 300;
          color: var(--text-main, #111827);
        }

        .search_btn {
          width: 28px;
          height: 28px;
          position: absolute;
          top: 4px;
          left: 230px;

          img {
            height: 100%;
            width: 100%;
            cursor: pointer;
            object-fit: cover;
          }
        }
      }

      .search_right {
        display: flex;
        align-items: center;
        color: var(--text-muted, #9AA0AC);
        cursor: pointer;
        transition: color 0.2s ease;

        i {
          font-size: 16px;
          line-height: 1;
        }

        .search_right_text {
          font-family: PingFangSC-Light, PingFang SC;
          margin: 5px 0 5px 8px;
          font-size: 14px;
          font-weight: 400;
          color: inherit;
        }
      }

      .search_right:hover {
        color: var(--brand-blue, #1A1D24);

        .search_right_text {
          color: inherit;
        }
      }
    }

    .game_list,
    .equip_list,
    .gold_list {
      .select_game_empty {
        width: 100%;
        min-height: 450px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .game_list {
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
	      overflow: visible;

      .game_other_business {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 26px 0;
        background: url("../../../assets/image/AllGame/selectGame/OB_background.png") no-repeat;

        > img:first-of-type {
          margin: 0 24px 0 30px;
        }

        > img:last-of-type {
          margin: 0 30px 0 24px;
        }

        .game_other_business_list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;

          .game_other_business_item {
            cursor: pointer;
            position: relative;

            .game_other_business_tag {
              position: absolute;
              top: -2px;
              right: 70px;
            }
          }
        }
      }

      .game_list_banner {
        margin: 18px 0 0;

        img {
          cursor: pointer;
          max-width: 1144px;
        }
      }

      .game_list_details_box {
        width: 1144px;
        margin: 0 28px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        display: flex;
        flex-direction: column;
        position: relative;
        transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

        .game_list_details {
          min-height: 132px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 18px 0;
          //cursor: pointer;
          .details_img {
            width: 220px;
            height: 124px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            border-radius: 4px;
            background: var(--bg-section, #F7F5F2);

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.25s ease;
            }

          }

          .topAcc {
            position: absolute;
            width: 78px;
            top: 21px;
            left: 0;
          }

	          .details_info {
	            width: 500px;
	            margin: 0;
	            position: relative;

            .apexTag {
              width: 89px;
              height: 53px;
              position: absolute;
              left: 85px;
              top: -18px;
            }


            .details_info_top {
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 500;
              color: var(--text-main, #111827);
              margin-bottom: 8px;
              height: 44px;
              display: -webkit-box;
              display: -ms-grid;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              line-height: 22px;
              overflow: hidden;
              text-align: justify; /*实现两端对齐*/
              text-justify: newspaper; /*通过增加或减少字或字母之间的空格对齐文本*/
              word-break: break-all; /*允许在单词内换行*/
              transition: color 0.2s ease;

              &:hover {
                color: var(--brand-blue, #1A1D24);
                overflow: visible;
              }

              .DIT_gameName {
                //background: #FCAD13;
                //border-radius: 4px;
                //font-size: 15px;
                //font-family: PingFangSC-Light, PingFang SC;
                //font-weight: 400;
                //color: #FFFFFF;
                //padding: 0 17px 0 18px;
                //margin-right: 5px;
                img:nth-of-type(1) {
                  width: 80px;
                  height: 20px;
                }

              }
            }

            .game_list_details_content {
              box-sizing: border-box;
              padding: 14px 16px;
	              background: rgba(30, 41, 59, 0.94);
	              border: 1px solid rgba(191, 219, 254, 0.18);
              border-radius: 4px;
              opacity: 0;
              visibility: hidden;
              pointer-events: none;
              position: absolute;
              top: 52px;
              left: 0;
              width: 520px;
              max-height: 220px;
	              box-shadow: 0 18px 36px rgba(15, 23, 42, 0.22);
              z-index: 30;
              overflow: visible;
              transform: translateY(-6px);
              transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
              cursor: text;
              user-select: text;

              &::before {
                content: "";
                position: absolute;
                top: -12px;
                left: 0;
                width: 100%;
                height: 12px;
                background: transparent;
              }

              &::after {
                content: "";
                position: absolute;
                top: -7px;
                left: 24px;
                width: 12px;
                height: 12px;
                box-sizing: border-box;
	                background: rgba(30, 41, 59, 0.94);
	                border-top: 1px solid rgba(191, 219, 254, 0.18);
	                border-left: 1px solid rgba(191, 219, 254, 0.18);
                transform: rotate(45deg);
              }

              .game_list_details_content_title {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
	                color: #FFFFFF;
                line-height: 20px;
                margin-bottom: 8px;
                cursor: text;
                user-select: text;
              }

              .game_list_details_content_detail {
                //font-size: 14px;
                //font-family: PingFangSC-Thin, PingFang SC;
                //font-weight: 300;
                //color: #5B5B5B;
                //line-height: 20px;
                //width: 1122px;

                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 400;
	                color: rgba(255, 255, 255, 0.86);
                line-height: 21px;
                max-height: 168px;
                overflow-y: auto;
                cursor: text;
                user-select: text;
              }
            }

            .details_info_mid {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              margin-bottom: 8px;

              span {
                width: auto;
                max-width: 31%;
                margin: 0 8px 6px 0;
                padding: 3px 8px;
                box-sizing: border-box;
                border-radius: 4px;
                background: var(--bg-section, #F7F5F2);
                border: 1px solid var(--border-soft, #E8E4DE);
                font-size: 13px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: var(--text-secondary, #5A5F6B);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .details_info_bot {
              display: flex;
              flex-direction: row;

              span {
                font-size: 13px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: var(--text-muted, #9AA0AC);
              }

              .release_time {
                margin-right: 36px;
              }

              .hot_pic {
                display: flex;
                flex-direction: row;
                align-items: center;

                img {
                  width: 18px;
                  height: 18px;
                  object-fit: cover;
                  margin: 0 6px 0 0;
                }
              }
            }
          }

          .details_price {
            width: 148px;
            min-height: 92px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-start;
            gap: 7px;
            font-size: 20px;
            line-height: 1;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--primary, #FF7A1A);

            .priceBadges {
              display: flex;
              justify-content: flex-end;
              min-height: 28px;
              width: 100%;
            }

            .priceValue {
              max-width: 100%;
              font-size: 22px;
              line-height: 26px;
              font-weight: 700;
              color: var(--primary, #FF7A1A);
              word-break: break-all;
            }

            .priceTags {
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 5px;
              width: 100%;
            }

            img {
              width: 80px;
              height: 20px;
              display: block;
            }

            /deep/ .sell-sincerity-box {
              display: flex;
              justify-content: flex-end;
              width: 100%;
            }

            .renewalTap {
              position: relative;
              width: 80px;
              height: 20px;
              // margin: 0 auto;
              .renewalTooltip {
                display: none;
                position: absolute;
                bottom: -55px;
                left: -60px;
                width: 180px;
                height: 48px;
                line-height: 48px;
                text-align: center;
                background: var(--bg-card, #FFFFFF);
                box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
                opacity: 1;
                border: 1px solid var(--border-soft, #E8E4DE);
                font-size: 14px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: var(--brand-blue, #1A1D24);
                border-radius: 4px;

                &::before {
                  right: 50px;
                  top: -11px;
                  content: "";
                  display: block;
                  width: 0;
                  height: 0;
                  border-bottom: solid 10px;
                  border-right: solid 5px;
                  border-left: solid 5px;
                  border-color: rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) var(--border-soft, #E8E4DE) rgba(255, 255, 255, 0);
                  position: absolute;
                  z-index: 2;
                }

                &::after {
                  right: 50px;
                  top: -9px;
                  content: "";
                  display: block;
                  width: 0;
                  height: 0;
                  border-bottom: solid 10px;
                  border-right: solid 5px;
                  border-left: solid 5px;
                  border-color: rgba(255, 255, 255, 0) rgba(255, 255, 255, 0) var(--bg-card, #FFFFFF) rgba(255, 255, 255, 0);
                  position: absolute;
                  z-index: 3;
                }
              }

            }

            .renewalTap:hover {
              .renewalTooltip {
                display: block;
              }
            }
          }

          .details_btn {
            width: 128px;
            flex: 0 0 128px;
            margin-right: 10px;

            a, div {
              width: 128px;
              height: 36px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: var(--text-main, #111827);
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.2s ease;
            }

            a {
              border: none !important;
            }

            .detailsPrimaryBtn {
              background: var(--primary, #FF5A1F);
              border-radius: 3px;
              border: 1px solid transparent !important;
              margin-bottom: 10px;
              color: #FFFFFF !important;
              box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
            }

            .detailsPrimaryBtn:visited,
            .detailsPrimaryBtn:focus {
              color: #FFFFFF !important;
              background: var(--primary, #FF5A1F);
            }

            .detailsPrimaryBtn:hover {
              background: var(--primary-hover, #E84A12);
              color: #FFFFFF !important;
              border-color: transparent !important;
              box-shadow: 0 12px 24px rgba(255, 90, 31, 0.3);
            }

            a:not(.detailsPrimaryBtn), div:last-of-type {
              border-radius: 3px;
              border: 1.5px solid var(--bg-dark, #1A1D24);
              background: #FFFFFF;
              color: var(--text-main, #1A1D24);

              &:hover {
                color: var(--text-main, #1A1D24);
                background: var(--bg-tag, #F0EDE8);
                border-color: var(--bg-dark, #1A1D24);
              }
            }
          }
        }

      }

	      .game_list_details_box:hover {
	        background: linear-gradient(90deg, #FFFFFF 0%, #F7F5F2 48%, #FFFFFF 100%);
	        position: relative;

	        .game_list_details {
            .details_info {
              .details_info_top:hover + .game_list_details_content,
              .game_list_details_content:hover {
                opacity: 1;
                visibility: visible;
                pointer-events: auto;
                transform: translateY(0);
              }
            }
        }

      }

      #game_list_details_box_last {
        border-bottom: none;
      }

      .empty {
        margin: 40px 0 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 16px;

        img {
          margin: 0 0 10px;
        }
      }

      .pages {
        margin: 12px 0 22px 0;

        /deep/ .commonPagination {
          padding-top: 14px;
        }
      }
    }

    .equip_list {
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: visible;

	      .equip_list_header {
	        width: 1142px;
	        height: 46px;
	        background: var(--bg-section, #F7F5F2);
	        border: 1px solid var(--border-soft, #E8E4DE);
	        padding: 0 28px;
	        display: flex;
	        flex-direction: row;
	        align-items: center;
	        justify-content: space-between;

	        div {
	          text-align: center;
	          font-size: 14px;
	          font-family: PingFangSC-Thin, PingFang SC;
	          font-weight: 400;
	          color: var(--text-secondary, #5A5F6B);
	          line-height: 20px;
	        }

	        .EL_header_baseInfo {
	          width: 520px;
	        }

        .EL_header_sellPrice {
          width: 140px;
        }

        .EL_header_num {
          width: 140px;
        }

        .EL_header_btn {
          width: 152px;
        }
      }

      .equip_list_banner {
        margin: 18px 0;

        img {
          cursor: pointer;
          max-width: 1144px;
        }
      }

      .equip_list_details_box {
        width: 1200px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        display: flex;
        flex-direction: column;
        position: relative;

        .equip_list_details {
          min-height: 116px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 20px 28px;
          //cursor: pointer;
          .details_base_info {
            width: 520px;
            display: flex;
            flex-direction: row;

            .details_img {
              width: 112px;
              height: 112px;
              cursor: pointer;
              margin: 0 20px 0 0;
              border-radius: 4px;
              background: var(--bg-section, #F7F5F2);
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

	            .details_info {
	              width: 370px;
	              position: relative;

	              .details_info_top {
                display: block;
                font-size: 14px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                margin-bottom: 10px;
                line-height: 20px;
                overflow: hidden;

                .details_info_top_name {
                  font-size: 15px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  color: var(--text-main, #111827);
                  line-height: 21px;
                  margin: 0 0 5px 0;

                  span {
                    background: var(--brand-blue-light, #F0EDE8);
                    border-radius: 4px;
                    font-size: 13px;
                    font-family: PingFangSC-Light, PingFang SC;
                    font-weight: 500;
                    color: var(--brand-blue, #1A1D24);
                    padding: 2px 10px;
                    margin-right: 5px;
                  }
                }

                .details_info_top_content {
                  height: 40px;
                  display: -webkit-box;
                  display: -ms-grid;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  font-size: 14px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--text-main, #111827);
                  line-height: 20px;
                }

	              }

	              .details_info_mid {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-bottom: 10px;

                span {
                  width: 33.33%;
                  font-size: 13px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--text-secondary, #5A5F6B);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .details_info_bot {
                display: flex;
                flex-direction: row;

                span {
                  font-size: 13px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--text-muted, #9AA0AC);
                }

                .release_time {
                  margin-right: 100px;
                }

                .hot_pic {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  img {
                    height: 18px;
                    margin: 0 6px 0 0;
                  }
                }
              }
            }
          }

          .details_price {
            text-align: center;
            width: 140px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--primary, #FF7A1A);
          }

          .details_num {
            text-align: center;
            width: 140px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
          }

          .details_btn {
            margin-right: 10px;

            a, div {
              width: 124px;
              height: 34px;
              font-size: 14px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: var(--text-main, #111827);
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.2s ease;
            }

            a {
              border: none !important;
            }

            .detailsPrimaryBtn {
              background: var(--primary, #FF5A1F);
              border-radius: 3px;
              border: 1px solid transparent !important;
              margin-bottom: 10px;
              color: #FFFFFF !important;
              box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
            }

            .detailsPrimaryBtn:visited,
            .detailsPrimaryBtn:focus {
              color: #FFFFFF !important;
              background: var(--primary, #FF5A1F);
            }

            .detailsPrimaryBtn:hover {
              background: var(--primary-hover, #E84A12);
              color: #FFFFFF !important;
              border-color: transparent !important;
              box-shadow: 0 12px 24px rgba(255, 90, 31, 0.3);
            }

            a:not(.detailsPrimaryBtn), div:last-of-type {
              border-radius: 3px;
              border: 1.5px solid var(--bg-dark, #1A1D24);
              background: #FFFFFF;
              color: var(--text-main, #1A1D24);

              &:hover {
                color: var(--text-main, #1A1D24);
                background: var(--bg-tag, #F0EDE8);
                border-color: var(--bg-dark, #1A1D24);
              }
            }
          }
        }

      }

	      .equip_list_details_box:hover {
	        background: linear-gradient(90deg, #FFFFFF 0%, #F7F5F2 48%, #FFFFFF 100%);
	        box-shadow: none;
	        position: relative;
	      }

      .details_info {
        position: relative;
      }

      .details_info .equip_list_details_content {
        box-sizing: border-box;
        padding: 14px 16px;
	        background: rgba(30, 41, 59, 0.94);
	        border: 1px solid rgba(191, 219, 254, 0.18);
        border-radius: 4px;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        position: absolute;
        top: 72px;
        left: 0;
        width: 520px;
        max-height: 220px;
	        box-shadow: 0 18px 36px rgba(15, 23, 42, 0.22);
        z-index: 30;
        overflow: visible;
        transform: translateY(-6px);
        transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
        cursor: text;
        user-select: text;
      }

      .details_info .equip_list_details_content::before {
        content: "";
        position: absolute;
        top: -12px;
        left: 0;
        width: 100%;
        height: 12px;
        background: transparent;
      }

      .details_info .equip_list_details_content::after {
        content: "";
        position: absolute;
        top: -7px;
        left: 24px;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
	        background: rgba(30, 41, 59, 0.94);
	        border-top: 1px solid rgba(191, 219, 254, 0.18);
	        border-left: 1px solid rgba(191, 219, 254, 0.18);
        transform: rotate(45deg);
      }

      .details_info .equip_list_details_content_title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
	        color: #FFFFFF;
        line-height: 20px;
        margin-bottom: 8px;
        cursor: text;
        user-select: text;
      }

      .details_info .equip_list_details_content_detail {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
	        color: rgba(255, 255, 255, 0.86);
        line-height: 21px;
        max-height: 168px;
        overflow-y: auto;
        cursor: text;
        user-select: text;
      }

      .details_info:hover > .equip_list_details_content,
      .details_info .details_info_top:hover + .equip_list_details_content,
      .details_info .equip_list_details_content:hover {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: translateY(0);
      }

      #equip_list_details_box_last {
        border-bottom: none;
      }

      .pages {
        margin: 12px 0 22px 0;

        /deep/ .commonPagination {
          padding-top: 14px;
        }
      }
    }

    .gold_list {
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: visible;

      .gold_list_banner {
        margin: 18px 0;
        cursor: pointer;

        img {
          max-width: 1144px;
        }
      }

	      .gold_list_header {
	        width: 1142px;
	        height: 46px;
	        background: var(--bg-section, #F7F5F2);
	        border: 1px solid var(--border-soft, #E8E4DE);
	        padding: 0 28px;
	        display: flex;
	        flex-direction: row;
	        align-items: center;
	        justify-content: space-between;

	        div {
	          text-align: center;
	          font-size: 14px;
	          font-family: PingFangSC-Thin, PingFang SC;
	          font-weight: 400;
	          color: var(--text-secondary, #5A5F6B);
	          line-height: 20px;
	        }

	        .GL_header_baseInfo {
	          width: 520px;
	        }

        .GL_header_sellPrice {
          width: 140px;
        }

        .GL_header_num {
          width: 140px;
        }

        .GL_header_btn {
          width: 152px;
        }
      }

      .gold_list_details_box {
        width: 1200px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        display: flex;
        flex-direction: column;
        position: relative;

        .gold_list_details {
          min-height: 116px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 20px 28px;
          //cursor: pointer;
          .details_base_info {
            width: 520px;
            display: flex;
            flex-direction: row;

            .details_img {
              width: 112px;
              height: 112px;
              cursor: pointer;
              margin: 0 20px 0 0;
              border-radius: 4px;
              background: var(--bg-section, #F7F5F2);
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .details_info {
              width: 370px;

              .details_info_top {
                display: block;
                font-size: 14px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                margin-bottom: 10px;
                line-height: 20px;
                overflow: hidden;

                .details_info_top_name {
                  font-size: 15px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  color: var(--text-main, #111827);
                  line-height: 21px;
                  margin: 0 0 5px 0;

                  span {
                    background: var(--brand-blue-light, #F0EDE8);
                    border-radius: 4px;
                    font-size: 13px;
                    font-family: PingFangSC-Light, PingFang SC;
                    font-weight: 500;
                    color: var(--brand-blue, #1A1D24);
                    padding: 2px 10px;
                    margin-right: 5px;
                  }
                }

                .details_info_top_content {
                  height: 40px;
                  display: -webkit-box;
                  display: -ms-grid;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  font-size: 14px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--text-main, #111827);
                  line-height: 20px;
                }

	              }

              .details_info_mid {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin-bottom: 10px;

                span {
                  width: 33.33%;
                  font-size: 13px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--text-secondary, #5A5F6B);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .details_info_bot {
                display: flex;
                flex-direction: row;

                span {
                  font-size: 13px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--text-muted, #9AA0AC);
                }

                .release_time {
                  margin-right: 100px;
                }

                .hot_pic {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  img {
                    height: 18px;
                    margin: 0 6px 0 0;
                  }
                }
              }
            }
          }

          .details_price {
            text-align: center;
            width: 140px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--primary, #FF7A1A);

            .gold_convert {
              display: flex;
              flex-direction: row;
              height: 40px;
              border-radius: 4px;
              border: 1px solid var(--primary, #FF7A1A);

              .gold_convert_title {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                width: 36px;
                font-size: 12px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                background: var(--primary, #FF7A1A);
              }

              .gold_convert_text {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                div {
                  width: 103px;
                  margin: 1px 0;
                  font-size: 12px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 400;
                  color: var(--primary, #FF7A1A);
                  line-height: 17px;
                }
              }
            }
          }

          .details_num {
            text-align: center;
            width: 140px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--text-main, #111827);
          }

          .details_btn {
            margin-right: 10px;

            a, div {
              width: 124px;
              height: 34px;
              font-size: 14px;
              font-family: PingFangSC-Thin, PingFang SC;
              font-weight: 400;
              color: var(--text-main, #111827);
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.2s ease;
            }

            a {
              border: none !important;
            }

            .detailsPrimaryBtn {
              background: var(--primary, #FF5A1F);
              border-radius: 3px;
              border: 1px solid transparent !important;
              margin-bottom: 10px;
              color: #FFFFFF !important;
              box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
            }

            .detailsPrimaryBtn:visited,
            .detailsPrimaryBtn:focus {
              color: #FFFFFF !important;
              background: var(--primary, #FF5A1F);
            }

            .detailsPrimaryBtn:hover {
              background: var(--primary-hover, #E84A12);
              color: #FFFFFF !important;
              border-color: transparent !important;
              box-shadow: 0 12px 24px rgba(255, 90, 31, 0.3);
            }

            a:not(.detailsPrimaryBtn), div:last-of-type {
              border-radius: 3px;
              border: 1.5px solid var(--bg-dark, #1A1D24);
              background: #FFFFFF;
              color: var(--text-main, #1A1D24);

              &:hover {
                color: var(--text-main, #1A1D24);
                background: var(--bg-tag, #F0EDE8);
                border-color: var(--bg-dark, #1A1D24);
              }
            }
          }
        }

      }

	      .gold_list_details_box:hover {
	        background: linear-gradient(90deg, #FFFFFF 0%, #F7F5F2 48%, #FFFFFF 100%);
	        box-shadow: none;
	        position: relative;
	      }

      .details_info {
        position: relative;
      }

      .details_info .gold_list_details_content {
        box-sizing: border-box;
        padding: 14px 16px;
	        background: rgba(30, 41, 59, 0.94);
	        border: 1px solid rgba(191, 219, 254, 0.18);
        border-radius: 4px;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        position: absolute;
        top: 72px;
        left: 0;
        width: 520px;
        max-height: 220px;
	        box-shadow: 0 18px 36px rgba(15, 23, 42, 0.22);
        z-index: 30;
        overflow: visible;
        transform: translateY(-6px);
        transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
        cursor: text;
        user-select: text;
      }

      .details_info .gold_list_details_content::before {
        content: "";
        position: absolute;
        top: -12px;
        left: 0;
        width: 100%;
        height: 12px;
        background: transparent;
      }

      .details_info .gold_list_details_content::after {
        content: "";
        position: absolute;
        top: -7px;
        left: 24px;
        width: 12px;
        height: 12px;
        box-sizing: border-box;
	        background: rgba(30, 41, 59, 0.94);
	        border-top: 1px solid rgba(191, 219, 254, 0.18);
	        border-left: 1px solid rgba(191, 219, 254, 0.18);
        transform: rotate(45deg);
      }

      .details_info .gold_list_details_content_title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
	        color: #FFFFFF;
        line-height: 20px;
        margin-bottom: 8px;
        cursor: text;
        user-select: text;
      }

      .details_info .gold_list_details_content_detail {
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
	        color: rgba(255, 255, 255, 0.86);
        line-height: 21px;
        max-height: 168px;
        overflow-y: auto;
        cursor: text;
        user-select: text;
      }

      .details_info:hover > .gold_list_details_content,
      .details_info .details_info_top:hover + .gold_list_details_content,
      .details_info .gold_list_details_content:hover {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: translateY(0);
      }

      #gold_list_details_box_last {
        border-bottom: none;
      }

      .pages {
        margin: 12px 0 22px 0;

        /deep/ .commonPagination {
          padding-top: 14px;
        }
      }
    }
  }
}

</style>
